/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendHelperDto } from '../../models/backend-helper-dto';

export interface HandbookHelpersList$Params {
  /**
   * * `LogEntry.id` - LogEntry - id - ID
   * * `LogEntry.action_time` - LogEntry - action_time - время действия
   * * `LogEntry.user` - LogEntry - user - пользователь
   * * `LogEntry.content_type` - LogEntry - content_type - тип содержимого
   * * `LogEntry.object_id` - LogEntry - object_id - идентификатор объекта
   * * `LogEntry.object_repr` - LogEntry - object_repr - представление объекта
   * * `LogEntry.action_flag` - LogEntry - action_flag - тип действия
   * * `LogEntry.change_message` - LogEntry - change_message - сообщение об изменении
   * * `Permission.id` - Permission - id - ID
   * * `Permission.name` - Permission - name - имя
   * * `Permission.content_type` - Permission - content_type - тип содержимого
   * * `Permission.codename` - Permission - codename - кодовое название
   * * `Group.id` - Group - id - ID
   * * `Group.name` - Group - name - имя
   * * `Group.permissions` - Group - permissions - права
   * * `ContentType.id` - ContentType - id - ID
   * * `ContentType.app_label` - ContentType - app_label - app label
   * * `ContentType.model` - ContentType - model - имя класса модели
   * * `Session.session_key` - Session - session_key - ключ сессии
   * * `Session.session_data` - Session - session_data - данные сессии
   * * `Session.expire_date` - Session - expire_date - дата окончания
   * * `Token.key` - Token - key - Ключ
   * * `Token.user` - Token - user - Пользователь
   * * `Token.created` - Token - created - Создан
   * * `ProjectField.id` - ProjectField - id - ID
   * * `ProjectField.field` - ProjectField - field - Поле
   * * `ProjectField.required` - ProjectField - required - Является обязательным
   * * `ProjectField.desirable` - ProjectField - desirable - Является желательным
   * * `Currency.id` - Currency - id - ID
   * * `Currency.name` - Currency - name - name
   * * `Currency.short_name` - Currency - short_name - short name
   * * `Currency.name_en` - Currency - name_en - name en
   * * `Country.id` - Country - id - ID
   * * `Country.name` - Country - name - name
   * * `Country.name_en` - Country - name_en - name en
   * * `Country.code` - Country - code - code
   * * `Country.prefix` - Country - prefix - prefix
   * * `Country.currency` - Country - currency - currency
   * * `Industry.id` - Industry - id - ID
   * * `Industry.name` - Industry - name - name
   * * `Industry.locale` - Industry - locale - locale
   * * `Segment.id` - Segment - id - ID
   * * `Segment.industry` - Segment - industry - industry
   * * `Segment.name` - Segment - name - name
   * * `Segment.name_en` - Segment - name_en - name en
   * * `FinancingSource.id` - FinancingSource - id - ID
   * * `FinancingSource.source_name` - FinancingSource - source_name - source name
   * * `Region.id` - Region - id - ID
   * * `Region.country` - Region - country - country
   * * `Region.name` - Region - name - Название региона
   * * `Region.code` - Region - code - Код региона
   * * `Region.description` - Region - description - Описание региона
   * * `Project.id` - Project - id - ID
   * * `Project.is_blocked` - Project - is_blocked - Объект заблокирован из-за недостаточно высокого тарифа
   * * `Project.author` - Project - author - Автор проекта
   * * `Project.category` - Project - category - category
   * * `Project.name` - Project - name - Короткое название проекта
   * * `Project.short_description` - Project - short_description - Короткое описание проекта
   * * `Project.full_description` - Project - full_description - Полное описание проекта
   * * `Project.logo` - Project - logo - Логотип проекта
   * * `Project.financing_type` - Project - financing_type - Тип проекта
   * * `Project.industry_main` - Project - industry_main - industry main
   * * `Project.currency` - Project - currency - Валюта проекта
   * * `Project.currency_multiplication` - Project - currency_multiplication - Мультипликатор денежного измерения
   * * `Project.time_detalization` - Project - time_detalization - Детализация проекта
   * * `Project.country` - Project - country - Страна
   * * `Project.region` - Project - region - регион
   * * `Project.fin_source_equity` - Project - fin_source_equity - собственный капитал
   * * `Project.fin_source_credit` - Project - fin_source_credit - кредит
   * * `Project.fin_source_leasing` - Project - fin_source_leasing - лизинг
   * * `Project.fin_source_venture` - Project - fin_source_venture - Венчурный фонд
   * * `Project.fin_source_business_angel` - Project - fin_source_business_angel - Бизнес ангел
   * * `Project.use_purchases` - Project - use_purchases - есть авансы, задолженность по оплатам, складские остатки
   * * `Project.comments` - Project - comments - comments
   * * `Project.create_date` - Project - create_date - Дата создания проекта
   * * `Project.update_date` - Project - update_date - Дата обновления проекта
   * * `Project.tariff` - Project - tariff - Тариф
   * * `Project.is_public` - Project - is_public - Является общедоступным
   * * `Project.active` - Project - active - Проект активен
   * * `Project.is_ml_project` - Project - is_ml_project - Проект подходит под задачи машинного обучения
   * * `Project.deletion_date` - Project - deletion_date - deletion date
   * * `Project.show_rating_to_investors` - Project - show_rating_to_investors - Показывать инвесторам рейтинг проекта
   * * `Project.start_date` - Project - start_date - Дата начала проекта
   * * `Project.years_to_payback` - Project - years_to_payback - Номинальный срок окупаемости в годах
   * * `Project.payback` - Project - payback - срок окупаемости
   * * `Project.rating` - Project - rating - Рейтинг проекта
   * * `Project.irr` - Project - irr - Внутренняя норма доходности (IRR), %
   * * `Project.npv` - Project - npv - Чистая приведенная стоимость (NPV), руб
   * * `Project.roi` - Project - roi - ROI
   * * `Project.roe` - Project - roe - ROE
   * * `Project.duration` - Project - duration - Длительность проекта
   * * `Project.industry_segments` - Project - industry_segments - industry segments
   * * `Project.subscribers` - Project - subscribers - Подписчики
   * * `ProjectConfig.id` - ProjectConfig - id - ID
   * * `ProjectConfig.project` - ProjectConfig - project - project
   * * `ProjectConfig.mode` - ProjectConfig - mode - Режим
   * * `ProjectConfig.scale` - ProjectConfig - scale - Масштаб проекта
   * * `ProjectConfig.detail_level` - ProjectConfig - detail_level - Уровень детализации расчета
   * * `ProjectConfig.industry` - ProjectConfig - industry - Сфера проекта
   * * `ProjectConfig.tax_rate` - ProjectConfig - tax_rate - Стандартная налоговая ставка или свои значения
   * * `ProjectConfig.equipment_property` - ProjectConfig - equipment_property - Техника или недвижимость
   * * `ProjectConfig.sales_model` - ProjectConfig - sales_model - Модель продаж
   * * `ProjectConfig.raw_materials_needed` - ProjectConfig - raw_materials_needed - Необходимость сырья
   * * `ProjectConfig.personnel_needed` - ProjectConfig - personnel_needed - Будет ли необходим персонал
   * * `ProjectConfig.property_needed` - ProjectConfig - property_needed - Планируете приобретать технику или недвижимость
   * * `ProjectConfig.use_eskhn` - ProjectConfig - use_eskhn - Использование ЕСХН в расчетах
   * * `ProjectConfig.working_capital_calculation` - ProjectConfig - working_capital_calculation - Расчет рабочего капитала
   * * `ProjectConfig.tax_mode` - ProjectConfig - tax_mode - Режим налогообложения
   * * `ProjectConfig.financing_sources` - ProjectConfig - financing_sources - Источники финансирования
   * * `ProjectTab.id` - ProjectTab - id - ID
   * * `ProjectTab.project` - ProjectTab - project - project
   * * `ProjectTab.tab` - ProjectTab - tab - Вкладка проекта
   * * `ProjectTab.filled` - ProjectTab - filled - Вкладка заполнена
   * * `AdditionalProjectInformation.id` - AdditionalProjectInformation - id - ID
   * * `AdditionalProjectInformation.project` - AdditionalProjectInformation - project - project
   * * `AdditionalProjectInformation.name_full` - AdditionalProjectInformation - name_full - Полное название проекта
   * * `AdditionalProjectInformation.country` - AdditionalProjectInformation - country - Страна
   * * `AdditionalProjectInformation.user_code` - AdditionalProjectInformation - user_code - Пользовательский (внутренний) код проекта
   * * `AdditionalProjectInformation.init_date` - AdditionalProjectInformation - init_date - Дата инициализации проекта
   * * `AdditionalProjectInformation.contract` - AdditionalProjectInformation - contract - Номер инвестиционного контракта
   * * `AdditionalProjectInformation.contract_date` - AdditionalProjectInformation - contract_date - Дата инвестиционного контракта
   * * `AdditionalProjectInformation.full_name_person_responsible` - AdditionalProjectInformation - full_name_person_responsible - full name person responsible
   * * `CopiedProject.id` - CopiedProject - id - ID
   * * `CopiedProject.project` - CopiedProject - project - project
   * * `CopiedProject.copied_project` - CopiedProject - copied_project - типовой проект
   * * `CopiedProject.name` - CopiedProject - name - Название типового проекта
   * * `CopiedProject.ext_switch` - CopiedProject - ext_switch - Доступ типового проекта другим пользователям организации
   * * `CopiedProject.finance_switch` - CopiedProject - finance_switch - Сохранять финансовые данные в типовом проекте
   * * `OrganizationForm.id` - OrganizationForm - id - ID
   * * `OrganizationForm.name` - OrganizationForm - name - Organization form
   * * `OrganizationForm.creation_date` - OrganizationForm - creation_date - Creation date
   * * `OrganizationForm.update_date` - OrganizationForm - update_date - Update date
   * * `ProjectCompany.id` - ProjectCompany - id - ID
   * * `ProjectCompany.project` - ProjectCompany - project - project
   * * `ProjectCompany.date_init` - ProjectCompany - date_init - Планируемая дата регистрации предприятия
   * * `ProjectCompany.name` - ProjectCompany - name - Рабочее название предприятия
   * * `ProjectCompany.organization_form` - ProjectCompany - organization_form - organization form
   * * `ProjectCompany.company_sme` - ProjectCompany - company_sme - Предприятие относится к разряду малого и среднего бизнеса
   * * `ProjectFile.id` - ProjectFile - id - ID
   * * `ProjectFile.project` - ProjectFile - project - project
   * * `ProjectFile.name` - ProjectFile - name - Название файла
   * * `ProjectFile.file` - ProjectFile - file - file
   * * `ProjectFile.file_type` - ProjectFile - file_type - Тип файла
   * * `ProjectFile.show_to_investors` - ProjectFile - show_to_investors - Показывать инвесторам
   * * `CapexVariant.id` - CapexVariant - id - ID
   * * `CapexVariant.is_blocked` - CapexVariant - is_blocked - Объект заблокирован из-за недостаточно высокого тарифа
   * * `CapexVariant.project` - CapexVariant - project - project
   * * `CapexVariant.variant_name` - CapexVariant - variant_name - Название варианта
   * * `CapexVariant.create_date` - CapexVariant - create_date - create date
   * * `CapexsGroup.id` - CapexsGroup - id - ID
   * * `CapexsGroup.name` - CapexsGroup - name - name
   * * `Capex.id` - Capex - id - ID
   * * `Capex.is_blocked` - Capex - is_blocked - Объект заблокирован из-за недостаточно высокого тарифа
   * * `Capex.group` - Capex - group - group
   * * `Capex.variant` - Capex - variant - variant
   * * `Capex.name` - Capex - name - Название объекта инвестирования
   * * `Capex.amount_capital_expenditure` - Capex - amount_capital_expenditure - Сумма капитальных расходов с НДС
   * * `Capex.VAT_rate` - Capex - VAT_rate - Ставка НДС с капитальных расходов
   * * `Capex.start_date` - Capex - start_date - Дата начала
   * * `Capex.end_date` - Capex - end_date - Дата окончания
   * * `Capex.VAT_refund` - Capex - VAT_refund - Планируется возмещение НДС из бюджета
   * * `Capex.leasing_switch` - Capex - leasing_switch - Объект будет в лизинге
   * * `Capex.deprication_period` - Capex - deprication_period - Срок амортизации
   * * `Capex.intangible_asset` - Capex - intangible_asset - Нематериальный актив
   * * `Capex.liquidation_cost_switch` - Capex - liquidation_cost_switch - Включать в расчет амортизации ликвидационные расходы
   * * `Capex.liquidation_profit_switch` - Capex - liquidation_profit_switch - Вычитать из расчета амортизации доходы при реализации имущества в конце срока
   * * `Capex.liquidation_cost` - Capex - liquidation_cost - Ликвидационные расходы с НДС
   * * `Capex.liquidation_cost_VAT_rate` - Capex - liquidation_cost_VAT_rate - Ставка НДС с лик. расходов
   * * `Capex.liquidation_profit` - Capex - liquidation_profit - Ожидаемая сумма от продажи в конце проекта с НДС
   * * `Capex.liquidation_profit_VAT_rate` - Capex - liquidation_profit_VAT_rate - Ставка НДС от суммы от продаж в конце проекта
   * * `Capex.taxdeprication_switch` - Capex - taxdeprication_switch - Налоговая амортизация отличается от бухгалтерской
   * * `Capex.taxdeprication_period` - Capex - taxdeprication_period - Срок амортизации для налога на прибыль
   * * `Capex.amortization_premium` - Capex - amortization_premium - Норма амортизационной премии при расчете налога на прибыль
   * * `CapexObject.id` - CapexObject - id - ID
   * * `CapexObject.capex` - CapexObject - capex - capex
   * * `CapexObject.name` - CapexObject - name - Название объекта
   * * `CapexObject.address` - CapexObject - address - Адрес объекта
   * * `CapexObject.cadastral_number` - CapexObject - cadastral_number - Кадастровый номер участка
   * * `CapexObject.land_area` - CapexObject - land_area - Площадь земельного участка, м2
   * * `CapexObject.farm` - CapexObject - farm - Фермерское хозяйство
   * * `CapexObject.project_works` - CapexObject - project_works - Выполняемые работы по проекту
   * * `CapexObject.create_date` - CapexObject - create_date - create date
   * * `CapexObjectFile.id` - CapexObjectFile - id - ID
   * * `CapexObjectFile.object` - CapexObjectFile - object - object
   * * `CapexObjectFile.name` - CapexObjectFile - name - название файла
   * * `CapexObjectFile.show_to_investors` - CapexObjectFile - show_to_investors - Показывать инвесторам
   * * `CapexObjectFile.file` - CapexObjectFile - file - file
   * * `CapexObjectFile.create_date` - CapexObjectFile - create_date - create date
   * * `ActualCapex.id` - ActualCapex - id - ID
   * * `ActualCapex.scenario` - ActualCapex - scenario - scenario
   * * `ActualCapex.created_by` - ActualCapex - created_by - created by
   * * `ActualCapex.planning_object_id` - ActualCapex - planning_object_id - planning object id
   * * `ActualCapex.source` - ActualCapex - source - source
   * * `ActualCapex.source_system` - ActualCapex - source_system - source system
   * * `ActualCapex.external_id` - ActualCapex - external_id - external id
   * * `ActualCapex.raw_payload` - ActualCapex - raw_payload - raw payload
   * * `ActualCapex.import_batch` - ActualCapex - import_batch - import batch
   * * `ActualCapex.created_at` - ActualCapex - created_at - created at
   * * `ActualCapex.updated_at` - ActualCapex - updated_at - updated at
   * * `ActualCapex.date` - ActualCapex - date - Дата
   * * `ActualCapex.name` - ActualCapex - name - Название
   * * `ActualCapex.amount` - ActualCapex - amount - Сумма
   * * `ActualCapex.vat_rate` - ActualCapex - vat_rate - НДС
   * * `ActualCapex.depreciation_period` - ActualCapex - depreciation_period - Период амортизации
   * * `ActualCapex.is_leasing` - ActualCapex - is_leasing - Лизинг
   * * `ActualCapex.description` - ActualCapex - description - Описание
   * * `SupportRequest.id` - SupportRequest - id - ID
   * * `SupportRequest.user` - SupportRequest - user - user
   * * `SupportRequest.creation_date` - SupportRequest - creation_date - creation date
   * * `SupportRequest.status_processing` - SupportRequest - status_processing - status processing
   * * `VentureFundVariant.id` - VentureFundVariant - id - ID
   * * `VentureFundVariant.variant_name` - VentureFundVariant - variant_name - Название варианта
   * * `VentureFundVariant.project` - VentureFundVariant - project - project
   * * `VentureFund.id` - VentureFund - id - ID
   * * `VentureFund.variant` - VentureFund - variant - variant
   * * `VentureFund.investment_name` - VentureFund - investment_name - Наименование инвестиций
   * * `VentureFund.fund_name` - VentureFund - fund_name - Название венчурного фонда
   * * `VentureFund.fund_email` - VentureFund - fund_email - Электронная почта венчурного фонда
   * * `VentureFundLoan.id` - VentureFundLoan - id - ID
   * * `VentureFundLoan.name` - VentureFundLoan - name - Название займа
   * * `VentureFundLoan.amount` - VentureFundLoan - amount - Сумма займа, руб
   * * `VentureFundLoan.date` - VentureFundLoan - date - Дата займа
   * * `VentureFundLoan.term` - VentureFundLoan - term - Срок займа, месяцев
   * * `VentureFundLoan.interest_rate` - VentureFundLoan - interest_rate - Процентная ставка, %
   * * `VentureFundLoan.repayment_periodicity` - VentureFundLoan - repayment_periodicity - Периодичность возврата основного долга
   * * `VentureFundLoan.created_at` - VentureFundLoan - created_at - Дата создания
   * * `VentureFundLoan.updated_at` - VentureFundLoan - updated_at - Дата обновления
   * * `VentureFundLoan.venture_fund` - VentureFundLoan - venture_fund - venture fund
   * * `VentureFundDividend.id` - VentureFundDividend - id - ID
   * * `VentureFundDividend.calculation_base` - VentureFundDividend - calculation_base - База расчета
   * * `VentureFundDividend.date` - VentureFundDividend - date - Дата инвестирования
   * * `VentureFundDividend.amount` - VentureFundDividend - amount - Сумма инвестирования, руб
   * * `VentureFundDividend.dividend_share` - VentureFundDividend - dividend_share - Доля дивидендов от чистой прибыли
   * * `VentureFundDividend.accrual_periodicity` - VentureFundDividend - accrual_periodicity - Периодичность начисления
   * * `VentureFundDividend.payment_term_days` - VentureFundDividend - payment_term_days - Срок оплаты после начисления, дней
   * * `VentureFundDividend.created_at` - VentureFundDividend - created_at - Дата создания
   * * `VentureFundDividend.updated_at` - VentureFundDividend - updated_at - Дата обновления
   * * `VentureFundDividend.venture_fund` - VentureFundDividend - venture_fund - venture fund
   * * `BusinessAngelVariant.id` - BusinessAngelVariant - id - ID
   * * `BusinessAngelVariant.variant_name` - BusinessAngelVariant - variant_name - Название
   * * `BusinessAngelVariant.project` - BusinessAngelVariant - project - project
   * * `BusinessAngel.id` - BusinessAngel - id - ID
   * * `BusinessAngel.variant` - BusinessAngel - variant - variant
   * * `BusinessAngel.angel_name` - BusinessAngel - angel_name - Имя бизнес-ангела
   * * `BusinessAngel.angel_email` - BusinessAngel - angel_email - Электронная почта бизнес-ангела
   * * `BusinessAngelLoan.id` - BusinessAngelLoan - id - ID
   * * `BusinessAngelLoan.name` - BusinessAngelLoan - name - Название займа
   * * `BusinessAngelLoan.amount` - BusinessAngelLoan - amount - Сумма займа, руб
   * * `BusinessAngelLoan.date` - BusinessAngelLoan - date - Дата займа
   * * `BusinessAngelLoan.term` - BusinessAngelLoan - term - Срок займа, месяцев
   * * `BusinessAngelLoan.interest_rate` - BusinessAngelLoan - interest_rate - Процентная ставка, %
   * * `BusinessAngelLoan.repayment_periodicity` - BusinessAngelLoan - repayment_periodicity - Периодичность возврата основного долга
   * * `BusinessAngelLoan.created_at` - BusinessAngelLoan - created_at - Дата создания
   * * `BusinessAngelLoan.updated_at` - BusinessAngelLoan - updated_at - Дата обновления
   * * `BusinessAngelLoan.business_angel` - BusinessAngelLoan - business_angel - business angel
   * * `BusinessAngelDividend.id` - BusinessAngelDividend - id - ID
   * * `BusinessAngelDividend.name` - BusinessAngelDividend - name - Название займа
   * * `BusinessAngelDividend.amount` - BusinessAngelDividend - amount - Сумма займа, руб
   * * `BusinessAngelDividend.date` - BusinessAngelDividend - date - Дата займа
   * * `BusinessAngelDividend.term` - BusinessAngelDividend - term - Срок займа, месяцев
   * * `BusinessAngelDividend.interest_rate` - BusinessAngelDividend - interest_rate - Процентная ставка, %
   * * `BusinessAngelDividend.repayment_periodicity` - BusinessAngelDividend - repayment_periodicity - Периодичность возврата основного долга
   * * `BusinessAngelDividend.created_at` - BusinessAngelDividend - created_at - Дата создания
   * * `BusinessAngelDividend.updated_at` - BusinessAngelDividend - updated_at - Дата обновления
   * * `BusinessAngelDividend.business_angel` - BusinessAngelDividend - business_angel - business angel
   * * `ChatRoom.id` - ChatRoom - id - ID
   * * `ChatRoom.room_id` - ChatRoom - room_id - room id
   * * `ChatRoom.project` - ChatRoom - project - project
   * * `ChatRoom.name` - ChatRoom - name - name
   * * `ChatRoom.members` - ChatRoom - members - members
   * * `ChatMessage.id` - ChatMessage - id - ID
   * * `ChatMessage.chat` - ChatMessage - chat - Чат
   * * `ChatMessage.sender` - ChatMessage - sender - Автор сообщения
   * * `ChatMessage.message` - ChatMessage - message - Текст сообщения
   * * `ChatMessage.timestamp` - ChatMessage - timestamp - Дата отправки
   * * `ChatMessage.is_read_by` - ChatMessage - is_read_by - Кем прочитано
   * * `OwnFundVariant.id` - OwnFundVariant - id - ID
   * * `OwnFundVariant.is_blocked` - OwnFundVariant - is_blocked - Объект заблокирован из-за недостаточно высокого тарифа
   * * `OwnFundVariant.project` - OwnFundVariant - project - project
   * * `OwnFundVariant.variant_name` - OwnFundVariant - variant_name - variant name
   * * `OwnFundVariant.create_date` - OwnFundVariant - create_date - create date
   * * `OwnFund.id` - OwnFund - id - ID
   * * `OwnFund.is_blocked` - OwnFund - is_blocked - Объект заблокирован из-за недостаточно высокого тарифа
   * * `OwnFund.variant` - OwnFund - variant - variant
   * * `OwnFund.source_sum` - OwnFund - source_sum - Сумма вложений
   * * `OwnFund.name` - OwnFund - name - name
   * * `OwnFund.source_date` - OwnFund - source_date - Дата взноса
   * * `OwnFund.source_investor` - OwnFund - source_investor - Инвестор
   * * `OwnFund.should_pay_dividends` - OwnFund - should_pay_dividends - Выплачивать дивиденты
   * * `OwnFund.profit_share_percentage` - OwnFund - profit_share_percentage - Доля чистой прибыли, приходящиеся на дивиденды
   * * `OwnFund.accrual_frequency` - OwnFund - accrual_frequency - Периодичность начисления дивидендов
   * * `OwnFund.ownership_share` - OwnFund - ownership_share - Доля владения
   * * `OwnFund.payment_due_days` - OwnFund - payment_due_days - Срок оплаты после начисления, дней
   * * `OwnFund.create_date` - OwnFund - create_date - create date
   * * `CreditVariant.id` - CreditVariant - id - ID
   * * `CreditVariant.is_blocked` - CreditVariant - is_blocked - Объект заблокирован из-за недостаточно высокого тарифа
   * * `CreditVariant.project` - CreditVariant - project - project
   * * `CreditVariant.variant_name` - CreditVariant - variant_name - variant name
   * * `CreditVariant.create_date` - CreditVariant - create_date - create date
   * * `CreditVariant.capex_variant` - CreditVariant - capex_variant - capex variant
   * * `Credit.id` - Credit - id - ID
   * * `Credit.is_blocked` - Credit - is_blocked - Объект заблокирован из-за недостаточно высокого тарифа
   * * `Credit.variant` - Credit - variant - variant
   * * `Credit.name` - Credit - name - name
   * * `Credit.lender` - Credit - lender - Банк
   * * `Credit.date` - Credit - date - Дата договора
   * * `Credit.sum_in_currancy` - Credit - sum_in_currancy - Сумма
   * * `Credit.date_in` - Credit - date_in - Дата получения
   * * `Credit.capitalization` - Credit - capitalization - Капитализация процентов
   * * `Credit.interest_rate` - Credit - interest_rate - Процентная ставка, %
   * * `Credit.tenor` - Credit - tenor - Срок займа, мес.
   * * `Credit.capex` - Credit - capex - Капекс
   * * `Credit.calculation_type` - Credit - calculation_type - Тип уплаты
   * * `Credit.grace_period_principal` - Credit - grace_period_principal - Грейс-период основного платежа, в мес.
   * * `Credit.grace_period_interest` - Credit - grace_period_interest - Грейс-период процентных платежей, в мес.
   * * `Credit.create_date` - Credit - create_date - create date
   * * `LeasingContractVariant.id` - LeasingContractVariant - id - ID
   * * `LeasingContractVariant.is_blocked` - LeasingContractVariant - is_blocked - Объект заблокирован из-за недостаточно высокого тарифа
   * * `LeasingContractVariant.project` - LeasingContractVariant - project - project
   * * `LeasingContractVariant.variant_name` - LeasingContractVariant - variant_name - variant name
   * * `LeasingContractVariant.create_date` - LeasingContractVariant - create_date - create date
   * * `LeasingContractVariant.capex_variant` - LeasingContractVariant - capex_variant - capex variant
   * * `LeasingContract.id` - LeasingContract - id - ID
   * * `LeasingContract.is_blocked` - LeasingContract - is_blocked - Объект заблокирован из-за недостаточно высокого тарифа
   * * `LeasingContract.variant` - LeasingContract - variant - variant
   * * `LeasingContract.lessor` - LeasingContract - lessor - Лизингодатель
   * * `LeasingContract.name` - LeasingContract - name - name
   * * `LeasingContract.initial_payment` - LeasingContract - initial_payment - Доля первоначального взноса
   * * `LeasingContract.capex` - LeasingContract - capex - capex
   * * `LeasingContract.contract_start_date` - LeasingContract - contract_start_date - Дата договора
   * * `LeasingContract.term_leasing_contract` - LeasingContract - term_leasing_contract - Срок лизингового договора, мес
   * * `LeasingContract.monthly_lease_payment` - LeasingContract - monthly_lease_payment - Ежемесячные лизинговые платежи (с НДС), руб
   * * `LeasingContract.redemption_sum_general` - LeasingContract - redemption_sum_general - Сумма выкупного платежа
   * * `LeasingContract.VAT_rate` - LeasingContract - VAT_rate - Ставка ндс
   * * `LeasingContract.distribution_redemption_switch` - LeasingContract - distribution_redemption_switch - Распределение выкупного платежа по периодам
   * * `LeasingContract.create_date` - LeasingContract - create_date - create date
   * * `WorkingCapitalParameter.id` - WorkingCapitalParameter - id - ID
   * * `WorkingCapitalParameter.is_blocked` - WorkingCapitalParameter - is_blocked - Объект заблокирован из-за недостаточно высокого тарифа
   * * `WorkingCapitalParameter.project` - WorkingCapitalParameter - project - project
   * * `WorkingCapitalParameter.variant_name` - WorkingCapitalParameter - variant_name - variant name
   * * `WorkingCapitalParameter.share_deferred_sales_general` - WorkingCapitalParameter - share_deferred_sales_general - Доля продаж с отсрочкой, %
   * * `WorkingCapitalParameter.percentage_immediate_pay_sales` - WorkingCapitalParameter - percentage_immediate_pay_sales - Доля продаж с незамедлительной оплатой
   * * `WorkingCapitalParameter.share_purchases_with_immediate_payment` - WorkingCapitalParameter - share_purchases_with_immediate_payment - Доля закупок с незамедлительной оплатой
   * * `WorkingCapitalParameter.share_advance_sales_general` - WorkingCapitalParameter - share_advance_sales_general - Доля продаж с авансами, %
   * * `WorkingCapitalParameter.turnover_deferred_sales_general` - WorkingCapitalParameter - turnover_deferred_sales_general - Средний срок отсрочки по продажам, дней
   * * `WorkingCapitalParameter.turnover_advance_sales_general` - WorkingCapitalParameter - turnover_advance_sales_general - Средний срок авансов от продаж, дней
   * * `WorkingCapitalParameter.share_different_purchase_general` - WorkingCapitalParameter - share_different_purchase_general - Доля закупок с отсрочкой платежа, %
   * * `WorkingCapitalParameter.share_advance_purchase_general` - WorkingCapitalParameter - share_advance_purchase_general - Доля закупок с авансовыми платежами, %
   * * `WorkingCapitalParameter.turnover_different_purchase_general` - WorkingCapitalParameter - turnover_different_purchase_general - Средний срок оплаты поставок, дней
   * * `WorkingCapitalParameter.turnover_advance_purchase_general` - WorkingCapitalParameter - turnover_advance_purchase_general - Срок авансов по закупкам, дней
   * * `WorkingCapitalParameter.turnover_inventory_general` - WorkingCapitalParameter - turnover_inventory_general - Срок оборачиваемости запасов, дней
   * * `WorkingCapitalParameter.turnover_vat_general` - WorkingCapitalParameter - turnover_vat_general - Средний срок остатков НДС по приобретенным ценностям (отложенного НДС), в днях
   * * `WorkingCapitalParameter.share_cash_sales_general` - WorkingCapitalParameter - share_cash_sales_general - Доля продаж с немедленной оплатой, %
   * * `WorkingCapitalParameter.wc_end_switch` - WorkingCapitalParameter - wc_end_switch - Списывать рабочий капитал в конце проекта
   * * `WorkingCapitalParameter.create_date` - WorkingCapitalParameter - create_date - Дата создания записи
   * * `ActualCredit.id` - ActualCredit - id - ID
   * * `ActualCredit.scenario` - ActualCredit - scenario - scenario
   * * `ActualCredit.created_by` - ActualCredit - created_by - created by
   * * `ActualCredit.planning_object_id` - ActualCredit - planning_object_id - planning object id
   * * `ActualCredit.source` - ActualCredit - source - source
   * * `ActualCredit.source_system` - ActualCredit - source_system - source system
   * * `ActualCredit.external_id` - ActualCredit - external_id - external id
   * * `ActualCredit.raw_payload` - ActualCredit - raw_payload - raw payload
   * * `ActualCredit.import_batch` - ActualCredit - import_batch - import batch
   * * `ActualCredit.created_at` - ActualCredit - created_at - created at
   * * `ActualCredit.updated_at` - ActualCredit - updated_at - updated at
   * * `ActualCredit.date` - ActualCredit - date - Дата
   * * `ActualCredit.name` - ActualCredit - name - Название
   * * `ActualCredit.bank` - ActualCredit - bank - Банк
   * * `ActualCredit.amount` - ActualCredit - amount - Сумма
   * * `ActualCredit.payment_type` - ActualCredit - payment_type - payment type
   * * `ActualCredit.type` - ActualCredit - type - type
   * * `ActualCredit.description` - ActualCredit - description - Описание
   * * `ActualLeasingContract.id` - ActualLeasingContract - id - ID
   * * `ActualLeasingContract.scenario` - ActualLeasingContract - scenario - scenario
   * * `ActualLeasingContract.created_by` - ActualLeasingContract - created_by - created by
   * * `ActualLeasingContract.planning_object_id` - ActualLeasingContract - planning_object_id - planning object id
   * * `ActualLeasingContract.source` - ActualLeasingContract - source - source
   * * `ActualLeasingContract.source_system` - ActualLeasingContract - source_system - source system
   * * `ActualLeasingContract.external_id` - ActualLeasingContract - external_id - external id
   * * `ActualLeasingContract.raw_payload` - ActualLeasingContract - raw_payload - raw payload
   * * `ActualLeasingContract.import_batch` - ActualLeasingContract - import_batch - import batch
   * * `ActualLeasingContract.created_at` - ActualLeasingContract - created_at - created at
   * * `ActualLeasingContract.updated_at` - ActualLeasingContract - updated_at - updated at
   * * `ActualLeasingContract.date` - ActualLeasingContract - date - Дата
   * * `ActualLeasingContract.name` - ActualLeasingContract - name - Название
   * * `ActualLeasingContract.lessor` - ActualLeasingContract - lessor - Лизингодатель
   * * `ActualLeasingContract.amount` - ActualLeasingContract - amount - Сумма
   * * `ActualLeasingContract.vat_rate` - ActualLeasingContract - vat_rate - НДС
   * * `ActualLeasingContract.payment_type` - ActualLeasingContract - payment_type - Тип платежа
   * * `ActualLeasingContract.actual_capex` - ActualLeasingContract - actual_capex - Капекс, приобретаемый в лизинг
   * * `ActualLeasingContract.description` - ActualLeasingContract - description - Описание
   * * `ActualOwnFund.id` - ActualOwnFund - id - ID
   * * `ActualOwnFund.scenario` - ActualOwnFund - scenario - scenario
   * * `ActualOwnFund.created_by` - ActualOwnFund - created_by - created by
   * * `ActualOwnFund.planning_object_id` - ActualOwnFund - planning_object_id - planning object id
   * * `ActualOwnFund.source` - ActualOwnFund - source - source
   * * `ActualOwnFund.source_system` - ActualOwnFund - source_system - source system
   * * `ActualOwnFund.external_id` - ActualOwnFund - external_id - external id
   * * `ActualOwnFund.raw_payload` - ActualOwnFund - raw_payload - raw payload
   * * `ActualOwnFund.import_batch` - ActualOwnFund - import_batch - import batch
   * * `ActualOwnFund.created_at` - ActualOwnFund - created_at - created at
   * * `ActualOwnFund.updated_at` - ActualOwnFund - updated_at - updated at
   * * `ActualOwnFund.date` - ActualOwnFund - date - Дата
   * * `ActualOwnFund.name` - ActualOwnFund - name - Название
   * * `ActualOwnFund.amount` - ActualOwnFund - amount - Сумма
   * * `ActualOwnFund.investor` - ActualOwnFund - investor - Инвестор
   * * `ActualOwnFund.description` - ActualOwnFund - description - Описание
   * * `ActualWorkingCapital.id` - ActualWorkingCapital - id - ID
   * * `ActualWorkingCapital.scenario` - ActualWorkingCapital - scenario - scenario
   * * `ActualWorkingCapital.created_by` - ActualWorkingCapital - created_by - created by
   * * `ActualWorkingCapital.planning_object_id` - ActualWorkingCapital - planning_object_id - planning object id
   * * `ActualWorkingCapital.source` - ActualWorkingCapital - source - source
   * * `ActualWorkingCapital.source_system` - ActualWorkingCapital - source_system - source system
   * * `ActualWorkingCapital.external_id` - ActualWorkingCapital - external_id - external id
   * * `ActualWorkingCapital.raw_payload` - ActualWorkingCapital - raw_payload - raw payload
   * * `ActualWorkingCapital.import_batch` - ActualWorkingCapital - import_batch - import batch
   * * `ActualWorkingCapital.created_at` - ActualWorkingCapital - created_at - created at
   * * `ActualWorkingCapital.updated_at` - ActualWorkingCapital - updated_at - updated at
   * * `ActualWorkingCapital.month` - ActualWorkingCapital - month - Месяц
   * * `ActualWorkingCapital.year` - ActualWorkingCapital - year - Год
   * * `ActualWorkingCapital.tmc` - ActualWorkingCapital - tmc - ТМЦ
   * * `ActualWorkingCapital.customer_advances` - ActualWorkingCapital - customer_advances - Авансы от клиентов
   * * `ActualWorkingCapital.customer_accounts_receivable` - ActualWorkingCapital - customer_accounts_receivable - Дебиторская задолженность клиентов
   * * `ActualWorkingCapital.supplier_advances` - ActualWorkingCapital - supplier_advances - Авансы поставщикам
   * * `ActualWorkingCapital.supplier_accounts_payable` - ActualWorkingCapital - supplier_accounts_payable - Кредиторская задолженность поставщикам
   * * `ActualWorkingCapital.vat_balance_on_purchased_assets` - ActualWorkingCapital - vat_balance_on_purchased_assets - НДС по приобретенным активам
   * * `KeyRate.id` - KeyRate - id - ID
   * * `KeyRate.rate` - KeyRate - rate - Ключевая ставка ЦБ РФ
   * * `TaxPrm.id` - TaxPrm - id - ID
   * * `TaxPrm.is_blocked` - TaxPrm - is_blocked - Объект заблокирован из-за недостаточно высокого тарифа
   * * `TaxPrm.variant_name` - TaxPrm - variant_name - variant name
   * * `TaxPrm.project` - TaxPrm - project - project
   * * `TaxPrm.tax_simulation` - TaxPrm - tax_simulation - моделирование налогов
   * * `TaxPrm.tax_min_burden` - TaxPrm - tax_min_burden - Налоговая нагрузка
   * * `TaxPrm.tax_min_burden_base` - TaxPrm - tax_min_burden_base - База для расчета налога
   * * `TaxPrm.calculation_frequency` - TaxPrm - calculation_frequency - Частота расчета
   * * `TaxPrm.vat_standart_rate` - TaxPrm - vat_standart_rate - НДС (стандартная ставка), %
   * * `TaxPrm.vat_preferential_rate` - TaxPrm - vat_preferential_rate - НДС (льготная ставка), %
   * * `TaxPrm.vat_export_rate` - TaxPrm - vat_export_rate - НДС (экспортная ставка), %
   * * `TaxPrm.income_tax` - TaxPrm - income_tax - Налог на прибыль, %
   * * `TaxPrm.social_tax` - TaxPrm - social_tax - Социальный налог, %
   * * `TaxPrm.summ_ndpi` - TaxPrm - summ_ndpi - Сумма НДПИ
   * * `TaxPrm.multiplier_ndpi` - TaxPrm - multiplier_ndpi - Налоговый мультипликатор НДПИ
   * * `TaxPrm.allowance_ndpi` - TaxPrm - allowance_ndpi - Налоговая надбавка НДПИ
   * * `TaxPrm.summ_excise` - TaxPrm - summ_excise - Сумма акциза
   * * `TaxPrm.multiplier_excise` - TaxPrm - multiplier_excise - Налоговый мультипликатор акциза
   * * `TaxPrm.allowance_excise` - TaxPrm - allowance_excise - Налоговая надбавка акциза
   * * `TaxPrm.create_date` - TaxPrm - create_date - create date
   * * `TaxMin.id` - TaxMin - id - ID
   * * `TaxMin.is_blocked` - TaxMin - is_blocked - Объект заблокирован из-за недостаточно высокого тарифа
   * * `TaxMin.tax` - TaxMin - tax - tax
   * * `TaxMin.tax_burden` - TaxMin - tax_burden - Налоговая нагрузка
   * * `TaxMin.tax_burden_base` - TaxMin - tax_burden_base - База для расчета налога
   * * `TaxMin.calculation_frequency` - TaxMin - calculation_frequency - Частота расчета
   * * `TaxMin.create_date` - TaxMin - create_date - create date
   * * `TaxStandard.id` - TaxStandard - id - ID
   * * `TaxStandard.is_blocked` - TaxStandard - is_blocked - Объект заблокирован из-за недостаточно высокого тарифа
   * * `TaxStandard.tax` - TaxStandard - tax - tax
   * * `TaxStandard.vat_standard_rate` - TaxStandard - vat_standard_rate - НДС (стандартная ставка), %
   * * `TaxStandard.vat_preferential_rate` - TaxStandard - vat_preferential_rate - НДС (льготная ставка), %
   * * `TaxStandard.vat_export_rate` - TaxStandard - vat_export_rate - НДС (экспортная ставка), %
   * * `TaxStandard.income_tax` - TaxStandard - income_tax - Налог на прибыль, %
   * * `TaxStandard.social_tax` - TaxStandard - social_tax - Социальный налог, %
   * * `TaxStandard.summ_ndpi` - TaxStandard - summ_ndpi - Сумма НДПИ
   * * `TaxStandard.multiplier_ndpi` - TaxStandard - multiplier_ndpi - Налоговый мультипликатор НДПИ
   * * `TaxStandard.allowance_ndpi` - TaxStandard - allowance_ndpi - Налоговая надбавка НДПИ
   * * `TaxStandard.summ_excise` - TaxStandard - summ_excise - Сумма акциза
   * * `TaxStandard.multiplier_excise` - TaxStandard - multiplier_excise - Налоговый мультипликатор акциза
   * * `TaxStandard.allowance_excise` - TaxStandard - allowance_excise - Налоговая надбавка акциза
   * * `TaxStandard.ndfl` - TaxStandard - ndfl - НДФЛ, %
   * * `TaxStandard.accident_tax` - TaxStandard - accident_tax - Ставка взносов от несчастных случаев и профзаболеваний, %
   * * `TaxStandard.create_date` - TaxStandard - create_date - create date
   * * `TaxSpecial.id` - TaxSpecial - id - ID
   * * `TaxSpecial.is_blocked` - TaxSpecial - is_blocked - Объект заблокирован из-за недостаточно высокого тарифа
   * * `TaxSpecial.tax` - TaxSpecial - tax - tax
   * * `TaxSpecial.tax_regime` - TaxSpecial - tax_regime - Выберите налоговый режим
   * * `TaxSpecial.minimum_tax_usn_income_expenses` - TaxSpecial - minimum_tax_usn_income_expenses - Минимальный налог для УСН (доходы минус расходы), %
   * * `TaxSpecial.tax_rate_usn_income` - TaxSpecial - tax_rate_usn_income - Налоговая ставка для УСН (доходы), %
   * * `TaxSpecial.tax_rate_usn_income_expenses` - TaxSpecial - tax_rate_usn_income_expenses - Налоговая ставка для УСН (доходы минус расходы), %
   * * `TaxSpecial.tax_rate_eshn` - TaxSpecial - tax_rate_eshn - Налоговая ставка для ЕСХН, %
   * * `TaxSpecial.annual_contribution_usn_income` - TaxSpecial - annual_contribution_usn_income - Ежегодный взнос для УСН (доходы), руб
   * * `TaxSpecial.annual_contribution_usn_income_expenses` - TaxSpecial - annual_contribution_usn_income_expenses - Ежегодный взнос для УСН (доходы минус расходы), руб
   * * `TaxSpecial.annual_contribution_indexation_usn_income` - TaxSpecial - annual_contribution_indexation_usn_income - Индексация ежегодных взносов для УСН (доходы), %
   * * `TaxSpecial.annual_contribution_indexation_usn_income_expenses` - TaxSpecial - annual_contribution_indexation_usn_income_expenses - Индексация ежегодных взносов для УСН (доходы минус расходы), %
   * * `TaxSpecial.tax_rate_individuals` - TaxSpecial - tax_rate_individuals - Налоговая ставка на продажи физическим лицам, %
   * * `TaxSpecial.tax_rate_legal_entities` - TaxSpecial - tax_rate_legal_entities - Налоговая ставка на продажи юридическим лицам, %
   * * `TaxSpecial.ndfl` - TaxSpecial - ndfl - НДФЛ, %
   * * `TaxSpecial.accident_tax` - TaxSpecial - accident_tax - Ставка взносов от несчастных случаев и профзаболеваний, %
   * * `TaxSpecial.social_tax` - TaxSpecial - social_tax - Социальный налог, %
   * * `TaxSpecial.create_date` - TaxSpecial - create_date - create date
   * * `DiscountRate.id` - DiscountRate - id - ID
   * * `DiscountRate.is_blocked` - DiscountRate - is_blocked - Объект заблокирован из-за недостаточно высокого тарифа
   * * `DiscountRate.variant_name` - DiscountRate - variant_name - variant name
   * * `DiscountRate.project` - DiscountRate - project - project
   * * `DiscountRate.discount_rate_general_install` - DiscountRate - discount_rate_general_install - Установленная ставка дисконтирования, % (общая для всех лет)
   * * `DiscountRate.discount_rate_source` - DiscountRate - discount_rate_source - Источник ставки дисконтирования
   * * `DiscountRate.reinvesting_rate` - DiscountRate - reinvesting_rate - Ставка реинвестирования, %
   * * `DiscountRate.reinvesting_rate_source` - DiscountRate - reinvesting_rate_source - Источник ставки реинвестирования
   * * `DiscountRate.create_date` - DiscountRate - create_date - create date
   * * `ActualTax.id` - ActualTax - id - ID
   * * `ActualTax.scenario` - ActualTax - scenario - scenario
   * * `ActualTax.created_by` - ActualTax - created_by - created by
   * * `ActualTax.planning_object_id` - ActualTax - planning_object_id - planning object id
   * * `ActualTax.source` - ActualTax - source - source
   * * `ActualTax.source_system` - ActualTax - source_system - source system
   * * `ActualTax.external_id` - ActualTax - external_id - external id
   * * `ActualTax.raw_payload` - ActualTax - raw_payload - raw payload
   * * `ActualTax.import_batch` - ActualTax - import_batch - import batch
   * * `ActualTax.created_at` - ActualTax - created_at - created at
   * * `ActualTax.updated_at` - ActualTax - updated_at - updated at
   * * `ActualTax.date` - ActualTax - date - Дата
   * * `ActualTax.type` - ActualTax - type - Тип налога
   * * `ActualTax.name` - ActualTax - name - Название
   * * `ActualTax.amount` - ActualTax - amount - Сумма
   * * `ActualTax.description` - ActualTax - description - Описание
   * * `TranslationToken.id` - TranslationToken - id - ID
   * * `TranslationToken.key` - TranslationToken - key - key
   * * `TranslationToken.description` - TranslationToken - description - description
   * * `TranslationValue.id` - TranslationValue - id - ID
   * * `TranslationValue.token` - TranslationValue - token - token
   * * `TranslationValue.locale` - TranslationValue - locale - locale
   * * `TranslationValue.value` - TranslationValue - value - value
   * * `OpexVariant.id` - OpexVariant - id - ID
   * * `OpexVariant.is_blocked` - OpexVariant - is_blocked - Объект заблокирован из-за недостаточно высокого тарифа
   * * `OpexVariant.project` - OpexVariant - project - project
   * * `OpexVariant.variant_name` - OpexVariant - variant_name - variant name
   * * `OpexVariant.product_varinat` - OpexVariant - product_varinat - product varinat
   * * `OpexsGroup.id` - OpexsGroup - id - ID
   * * `OpexsGroup.name` - OpexsGroup - name - Название группы
   * * `Material.id` - Material - id - ID
   * * `Material.is_blocked` - Material - is_blocked - Объект заблокирован из-за недостаточно высокого тарифа
   * * `Material.start_date` - Material - start_date - Дата начала расхода
   * * `Material.end_date` - Material - end_date - Дата окончания расхода
   * * `Material.costs_correspond_to_sales_dates` - Material - costs_correspond_to_sales_dates - Затраты соответствуют датам продаж
   * * `Material.amount` - Material - amount - Сумма с НДС в месяц, рублей
   * * `Material.vat_rate` - Material - vat_rate - Ставка НДС
   * * `Material.price_indexation` - Material - price_indexation - Индексация закупочной цены по продажам
   * * `Material.indexing_value` - Material - indexing_value - Значение индексации
   * * `Material.indexing_frequency` - Material - indexing_frequency - Частота индексации
   * * `Material.include_in_profit_tax_calculation` - Material - include_in_profit_tax_calculation - Включать расход в расчет налога на прибыль
   * * `Material.product_type` - Material - product_type - product type
   * * `Material.product_id` - Material - product_id - product id
   * * `Material.variant` - Material - variant - variant
   * * `Material.name` - Material - name - Наименование сырья, материала, конструкции
   * * `Material.provider` - Material - provider - Поставщик
   * * `Material.business_activity` - Material - business_activity - Классификация по деловой активности
   * * `Material.quantity_opexs` - Material - quantity_opexs - Количество затрат
   * * `Material.unit` - Material - unit - Применяемая единица измерения
   * * `Product.id` - Product - id - ID
   * * `Product.is_blocked` - Product - is_blocked - Объект заблокирован из-за недостаточно высокого тарифа
   * * `Product.start_date` - Product - start_date - Дата начала расхода
   * * `Product.end_date` - Product - end_date - Дата окончания расхода
   * * `Product.costs_correspond_to_sales_dates` - Product - costs_correspond_to_sales_dates - Затраты соответствуют датам продаж
   * * `Product.amount` - Product - amount - Сумма с НДС в месяц, рублей
   * * `Product.vat_rate` - Product - vat_rate - Ставка НДС
   * * `Product.price_indexation` - Product - price_indexation - Индексация закупочной цены по продажам
   * * `Product.indexing_value` - Product - indexing_value - Значение индексации
   * * `Product.indexing_frequency` - Product - indexing_frequency - Частота индексации
   * * `Product.include_in_profit_tax_calculation` - Product - include_in_profit_tax_calculation - Включать расход в расчет налога на прибыль
   * * `Product.product_type` - Product - product_type - product type
   * * `Product.product_id` - Product - product_id - product id
   * * `Product.variant` - Product - variant - variant
   * * `Product.name` - Product - name - Наименование сырья, материала, конструкции
   * * `Product.provider` - Product - provider - Поставщик
   * * `Product.business_activity` - Product - business_activity - Классификация по деловой активности
   * * `Product.quantity_opexs` - Product - quantity_opexs - Количество затрат
   * * `Product.unit` - Product - unit - Применяемая единица измерения
   * * `Salary.id` - Salary - id - ID
   * * `Salary.is_blocked` - Salary - is_blocked - Объект заблокирован из-за недостаточно высокого тарифа
   * * `Salary.start_date` - Salary - start_date - Дата начала расхода
   * * `Salary.end_date` - Salary - end_date - Дата окончания расхода
   * * `Salary.costs_correspond_to_sales_dates` - Salary - costs_correspond_to_sales_dates - Затраты соответствуют датам продаж
   * * `Salary.name` - Salary - name - Наименование расхода
   * * `Salary.amount` - Salary - amount - Сумма с НДС в месяц, рублей
   * * `Salary.vat_rate` - Salary - vat_rate - Ставка НДС
   * * `Salary.price_indexation` - Salary - price_indexation - Индексация закупочной цены по продажам
   * * `Salary.indexing_value` - Salary - indexing_value - Значение индексации
   * * `Salary.indexing_frequency` - Salary - indexing_frequency - Частота индексации
   * * `Salary.include_in_profit_tax_calculation` - Salary - include_in_profit_tax_calculation - Включать расход в расчет налога на прибыль
   * * `Salary.product_type` - Salary - product_type - product type
   * * `Salary.product_id` - Salary - product_id - product id
   * * `Salary.variant` - Salary - variant - variant
   * * `Salary.accounting_unit` - Salary - accounting_unit - Учетная единица
   * * `Salary.employee_name` - Salary - employee_name - Имя сотрудника
   * * `Salary.employee_position` - Salary - employee_position - Должность сотрудника
   * * `Salary.department_name` - Salary - department_name - Название подразделения
   * * `Salary.personnel_type` - Salary - personnel_type - Тип персонала
   * * `Salary.payment_type` - Salary - payment_type - Тип выплаты
   * * `Salary.payout_amount` - Salary - payout_amount - Сумма выплат
   * * `Salary.piece_rate_percentage` - Salary - piece_rate_percentage - Ставка сдельная, %
   * * `Salary.base_calculation_deal` - Salary - base_calculation_deal - База расчета сделки
   * * `Salary.is_subject_to_ndfl` - Salary - is_subject_to_ndfl - Облагается НДФЛ
   * * `Salary.is_subject_to_social_tax` - Salary - is_subject_to_social_tax - Облагается социальным налогом
   * * `Salary.calculate_insurance_contributions` - Salary - calculate_insurance_contributions - Рассчитывать взносы от несчастных случаев и профзаболеваний
   * * `Rent.id` - Rent - id - ID
   * * `Rent.is_blocked` - Rent - is_blocked - Объект заблокирован из-за недостаточно высокого тарифа
   * * `Rent.start_date` - Rent - start_date - Дата начала расхода
   * * `Rent.end_date` - Rent - end_date - Дата окончания расхода
   * * `Rent.costs_correspond_to_sales_dates` - Rent - costs_correspond_to_sales_dates - Затраты соответствуют датам продаж
   * * `Rent.amount` - Rent - amount - Сумма с НДС в месяц, рублей
   * * `Rent.vat_rate` - Rent - vat_rate - Ставка НДС
   * * `Rent.indexing_value` - Rent - indexing_value - Значение индексации
   * * `Rent.indexing_frequency` - Rent - indexing_frequency - Частота индексации
   * * `Rent.include_in_profit_tax_calculation` - Rent - include_in_profit_tax_calculation - Включать расход в расчет налога на прибыль
   * * `Rent.product_type` - Rent - product_type - product type
   * * `Rent.product_id` - Rent - product_id - product id
   * * `Rent.variant` - Rent - variant - variant
   * * `Rent.name` - Rent - name - Наименование объекта
   * * `Rent.lessor` - Rent - lessor - Арендодатель
   * * `Rent.address` - Rent - address - Адрес объекта
   * * `Rent.area` - Rent - area - Площадь объекта, кв.м
   * * `Rent.object_type` - Rent - object_type - Тип объекта
   * * `Rent.price_indexation` - Rent - price_indexation - Индексация арендного платежа по продажам
   * * `OtherOpex.id` - OtherOpex - id - ID
   * * `OtherOpex.is_blocked` - OtherOpex - is_blocked - Объект заблокирован из-за недостаточно высокого тарифа
   * * `OtherOpex.start_date` - OtherOpex - start_date - Дата начала расхода
   * * `OtherOpex.end_date` - OtherOpex - end_date - Дата окончания расхода
   * * `OtherOpex.costs_correspond_to_sales_dates` - OtherOpex - costs_correspond_to_sales_dates - Затраты соответствуют датам продаж
   * * `OtherOpex.amount` - OtherOpex - amount - Сумма с НДС в месяц, рублей
   * * `OtherOpex.vat_rate` - OtherOpex - vat_rate - Ставка НДС
   * * `OtherOpex.price_indexation` - OtherOpex - price_indexation - Индексация закупочной цены по продажам
   * * `OtherOpex.indexing_value` - OtherOpex - indexing_value - Значение индексации
   * * `OtherOpex.indexing_frequency` - OtherOpex - indexing_frequency - Частота индексации
   * * `OtherOpex.include_in_profit_tax_calculation` - OtherOpex - include_in_profit_tax_calculation - Включать расход в расчет налога на прибыль
   * * `OtherOpex.product_type` - OtherOpex - product_type - product type
   * * `OtherOpex.product_id` - OtherOpex - product_id - product id
   * * `OtherOpex.variant` - OtherOpex - variant - variant
   * * `OtherOpex.name` - OtherOpex - name - Наименование расхода
   * * `OtherOpex.quantity_opexs` - OtherOpex - quantity_opexs - Количество затрат
   * * `OtherOpex.unit` - OtherOpex - unit - Применяемая единица измерения
   * * `OtherOpex.business_activity` - OtherOpex - business_activity - Классификация по деловой активности
   * * `OtherOpex.economic_activity` - OtherOpex - economic_activity - Экономическая классификация
   * * `ActualMaterial.id` - ActualMaterial - id - ID
   * * `ActualMaterial.scenario` - ActualMaterial - scenario - scenario
   * * `ActualMaterial.created_by` - ActualMaterial - created_by - created by
   * * `ActualMaterial.planning_object_id` - ActualMaterial - planning_object_id - planning object id
   * * `ActualMaterial.source` - ActualMaterial - source - source
   * * `ActualMaterial.source_system` - ActualMaterial - source_system - source system
   * * `ActualMaterial.external_id` - ActualMaterial - external_id - external id
   * * `ActualMaterial.raw_payload` - ActualMaterial - raw_payload - raw payload
   * * `ActualMaterial.import_batch` - ActualMaterial - import_batch - import batch
   * * `ActualMaterial.created_at` - ActualMaterial - created_at - created at
   * * `ActualMaterial.updated_at` - ActualMaterial - updated_at - updated at
   * * `ActualMaterial.date` - ActualMaterial - date - Дата
   * * `ActualMaterial.name` - ActualMaterial - name - Название
   * * `ActualMaterial.amount` - ActualMaterial - amount - Сумма
   * * `ActualMaterial.vat_rate` - ActualMaterial - vat_rate - НДС
   * * `ActualMaterial.description` - ActualMaterial - description - Описание
   * * `ActualMaterial.provider` - ActualMaterial - provider - Поставщик
   * * `ActualMaterial.business_activity` - ActualMaterial - business_activity - Классификация по деловой активности
   * * `ActualProduct.id` - ActualProduct - id - ID
   * * `ActualProduct.scenario` - ActualProduct - scenario - scenario
   * * `ActualProduct.created_by` - ActualProduct - created_by - created by
   * * `ActualProduct.planning_object_id` - ActualProduct - planning_object_id - planning object id
   * * `ActualProduct.source` - ActualProduct - source - source
   * * `ActualProduct.source_system` - ActualProduct - source_system - source system
   * * `ActualProduct.external_id` - ActualProduct - external_id - external id
   * * `ActualProduct.raw_payload` - ActualProduct - raw_payload - raw payload
   * * `ActualProduct.import_batch` - ActualProduct - import_batch - import batch
   * * `ActualProduct.created_at` - ActualProduct - created_at - created at
   * * `ActualProduct.updated_at` - ActualProduct - updated_at - updated at
   * * `ActualProduct.date` - ActualProduct - date - Дата
   * * `ActualProduct.name` - ActualProduct - name - Название
   * * `ActualProduct.amount` - ActualProduct - amount - Сумма
   * * `ActualProduct.vat_rate` - ActualProduct - vat_rate - НДС
   * * `ActualProduct.description` - ActualProduct - description - Описание
   * * `ActualProduct.provider` - ActualProduct - provider - Поставщик
   * * `ActualProduct.business_activity` - ActualProduct - business_activity - Классификация по деловой активности
   * * `ActualSalary.id` - ActualSalary - id - ID
   * * `ActualSalary.scenario` - ActualSalary - scenario - scenario
   * * `ActualSalary.created_by` - ActualSalary - created_by - created by
   * * `ActualSalary.planning_object_id` - ActualSalary - planning_object_id - planning object id
   * * `ActualSalary.source` - ActualSalary - source - source
   * * `ActualSalary.source_system` - ActualSalary - source_system - source system
   * * `ActualSalary.external_id` - ActualSalary - external_id - external id
   * * `ActualSalary.raw_payload` - ActualSalary - raw_payload - raw payload
   * * `ActualSalary.import_batch` - ActualSalary - import_batch - import batch
   * * `ActualSalary.created_at` - ActualSalary - created_at - created at
   * * `ActualSalary.updated_at` - ActualSalary - updated_at - updated at
   * * `ActualSalary.date` - ActualSalary - date - Дата
   * * `ActualSalary.name` - ActualSalary - name - Название
   * * `ActualSalary.amount` - ActualSalary - amount - Сумма
   * * `ActualSalary.vat_rate` - ActualSalary - vat_rate - НДС
   * * `ActualSalary.description` - ActualSalary - description - Описание
   * * `ActualSalary.accounting_unit` - ActualSalary - accounting_unit - Учетная единица
   * * `ActualSalary.employee_name` - ActualSalary - employee_name - Имя сотрудника
   * * `ActualSalary.employee_position` - ActualSalary - employee_position - Должность сотрудника
   * * `ActualSalary.department_name` - ActualSalary - department_name - Название подразделения
   * * `ActualSalary.personnel_type` - ActualSalary - personnel_type - Тип персонала
   * * `ActualSalary.payment_type` - ActualSalary - payment_type - Тип выплаты
   * * `ActualSalary.indexing_value` - ActualSalary - indexing_value - Значение индексации
   * * `ActualSalary.indexing_frequency` - ActualSalary - indexing_frequency - Частота индексации
   * * `ActualSalary.base_calculation_deal` - ActualSalary - base_calculation_deal - База расчета сделки
   * * `ActualSalary.product_type` - ActualSalary - product_type - Тип продукта
   * * `ActualSalary.product_id` - ActualSalary - product_id - ID продукта
   * * `ActualSalary.production_rate_amount` - ActualSalary - production_rate_amount - Ставка сдельная производственная
   * * `ActualSalary.rate_sales_amount` - ActualSalary - rate_sales_amount - Ставка сдельная от реализации
   * * `ActualSalary.is_subject_to_social_tax` - ActualSalary - is_subject_to_social_tax - Облагается социальным налогом
   * * `ActualSalary.calculate_insurance_contributions` - ActualSalary - calculate_insurance_contributions - Рассчитывать взносы от несчастных случаев и профзаболеваний
   * * `ActualRent.id` - ActualRent - id - ID
   * * `ActualRent.scenario` - ActualRent - scenario - scenario
   * * `ActualRent.created_by` - ActualRent - created_by - created by
   * * `ActualRent.planning_object_id` - ActualRent - planning_object_id - planning object id
   * * `ActualRent.source` - ActualRent - source - source
   * * `ActualRent.source_system` - ActualRent - source_system - source system
   * * `ActualRent.external_id` - ActualRent - external_id - external id
   * * `ActualRent.raw_payload` - ActualRent - raw_payload - raw payload
   * * `ActualRent.import_batch` - ActualRent - import_batch - import batch
   * * `ActualRent.created_at` - ActualRent - created_at - created at
   * * `ActualRent.updated_at` - ActualRent - updated_at - updated at
   * * `ActualRent.date` - ActualRent - date - Дата
   * * `ActualRent.name` - ActualRent - name - Название
   * * `ActualRent.amount` - ActualRent - amount - Сумма
   * * `ActualRent.vat_rate` - ActualRent - vat_rate - НДС
   * * `ActualRent.description` - ActualRent - description - Описание
   * * `ActualRent.lessor` - ActualRent - lessor - Арендодатель
   * * `ActualRent.address` - ActualRent - address - Адрес объекта
   * * `ActualRent.area` - ActualRent - area - Площадь объекта, кв.м
   * * `ActualRent.object_type` - ActualRent - object_type - Тип объекта
   * * `ActualRent.price_indexation` - ActualRent - price_indexation - Индексация арендного платежа по продажам
   * * `ActualRent.indexing_value` - ActualRent - indexing_value - Значение индексации
   * * `ActualRent.indexing_frequency` - ActualRent - indexing_frequency - Частота индексации
   * * `ActualOtherOpex.id` - ActualOtherOpex - id - ID
   * * `ActualOtherOpex.scenario` - ActualOtherOpex - scenario - scenario
   * * `ActualOtherOpex.created_by` - ActualOtherOpex - created_by - created by
   * * `ActualOtherOpex.planning_object_id` - ActualOtherOpex - planning_object_id - planning object id
   * * `ActualOtherOpex.source` - ActualOtherOpex - source - source
   * * `ActualOtherOpex.source_system` - ActualOtherOpex - source_system - source system
   * * `ActualOtherOpex.external_id` - ActualOtherOpex - external_id - external id
   * * `ActualOtherOpex.raw_payload` - ActualOtherOpex - raw_payload - raw payload
   * * `ActualOtherOpex.import_batch` - ActualOtherOpex - import_batch - import batch
   * * `ActualOtherOpex.created_at` - ActualOtherOpex - created_at - created at
   * * `ActualOtherOpex.updated_at` - ActualOtherOpex - updated_at - updated at
   * * `ActualOtherOpex.date` - ActualOtherOpex - date - Дата
   * * `ActualOtherOpex.name` - ActualOtherOpex - name - Название
   * * `ActualOtherOpex.amount` - ActualOtherOpex - amount - Сумма
   * * `ActualOtherOpex.vat_rate` - ActualOtherOpex - vat_rate - НДС
   * * `ActualOtherOpex.description` - ActualOtherOpex - description - Описание
   * * `ActualOtherOpex.business_activity` - ActualOtherOpex - business_activity - Классификация по деловой активности
   * * `ActualOtherOpex.economic_activity` - ActualOtherOpex - economic_activity - Экономическая классификация
   * * `InvestorApplication.id` - InvestorApplication - id - ID
   * * `InvestorApplication.investor` - InvestorApplication - investor - Инвестор
   * * `InvestorApplication.project` - InvestorApplication - project - Проект
   * * `InvestorApplication.deal_status` - InvestorApplication - deal_status - Статус сделки
   * * `InvestorApplication.processing_status` - InvestorApplication - processing_status - Статус обработки
   * * `ProductVariant.id` - ProductVariant - id - ID
   * * `ProductVariant.is_blocked` - ProductVariant - is_blocked - Объект заблокирован из-за недостаточно высокого тарифа
   * * `ProductVariant.project` - ProductVariant - project - project
   * * `ProductVariant.variant_name` - ProductVariant - variant_name - Название варианта
   * * `ProductVariant.create_date` - ProductVariant - create_date - create date
   * * `ProductVariant.calculation_tab` - ProductVariant - calculation_tab - Вкладка расчета
   * * `ProductGroup.id` - ProductGroup - id - ID
   * * `ProductGroup.variant` - ProductGroup - variant - variant
   * * `ProductGroup.name` - ProductGroup - name - name
   * * `ProductGroup.create_date` - ProductGroup - create_date - create date
   * * `Product.id` - Product - id - ID
   * * `Product.is_blocked` - Product - is_blocked - Объект заблокирован из-за недостаточно высокого тарифа
   * * `Product.variant` - Product - variant - variant
   * * `Product.name` - Product - name - Названия продукции, товаров, услуг
   * * `Product.product_unit` - Product - product_unit - Применяемая единица измерения продукта
   * * `Product.start_date` - Product - start_date - Дата начала продаж
   * * `Product.end_date` - Product - end_date - Дата окончания продаж
   * * `Product.sales_volume` - Product - sales_volume - Объем продаж в месяц
   * * `Product.VAT` - Product - VAT - Ставка НДС
   * * `Product.NDPI` - Product - NDPI - Облагается НДПИ
   * * `Product.excise_duty` - Product - excise_duty - Облагается акцизом
   * * `Product.value_indexation_period` - Product - value_indexation_period - Период индексации объема
   * * `Product.value_indexation` - Product - value_indexation - Индексация объема
   * * `Product.inflation_indexation_period` - Product - inflation_indexation_period - Период индексации инфляции
   * * `Product.inflation_indexation` - Product - inflation_indexation - Индексация инфляции
   * * `Product.price` - Product - price - Цена продукции
   * * `StandardProduct.id` - StandardProduct - id - ID
   * * `StandardProduct.is_blocked` - StandardProduct - is_blocked - Объект заблокирован из-за недостаточно высокого тарифа
   * * `StandardProduct.name` - StandardProduct - name - Название продукта
   * * `StandardProduct.start_date` - StandardProduct - start_date - Дата начала продаж
   * * `StandardProduct.group` - StandardProduct - group - group
   * * `StandardProduct.use_lead_generation` - StandardProduct - use_lead_generation - Использовать лидогенерацию
   * * `StandardProduct.potential_market_size` - StandardProduct - potential_market_size - Потенциальный объём рынка (PAM)
   * * `StandardProduct.quantity_pam` - StandardProduct - quantity_pam - Количество PAM, шт.
   * * `StandardProduct.tam_pam` - StandardProduct - tam_pam - TAM/PAM, %)
   * * `StandardProduct.total_target_market` - StandardProduct - total_target_market - Общий объём целевого рынка (TAM)
   * * `StandardProduct.quantity_tam` - StandardProduct - quantity_tam - Количество TAM, шт.
   * * `StandardProduct.sam_tam` - StandardProduct - sam_tam - SAM/TAM, %)
   * * `StandardProduct.available_market_size` - StandardProduct - available_market_size - Доступный объём рынка (SAM)
   * * `StandardProduct.quantity_sam` - StandardProduct - quantity_sam - Количество SAM, шт.
   * * `StandardProduct.call_conversion` - StandardProduct - call_conversion - Конверсия обращений, %)
   * * `StandardProduct.purchase_conversion` - StandardProduct - purchase_conversion - Конверсия покупок, %)
   * * `StandardProduct.round_values_to_integer` - StandardProduct - round_values_to_integer - Округлять значения до целого
   * * `StandardProduct.price` - StandardProduct - price - Цена с НДС, руб/шт
   * * `StandardProduct.tax_rate` - StandardProduct - tax_rate - Налоговая ставка
   * * `StandardProduct.annual_inflation` - StandardProduct - annual_inflation - Годовая инфляция, %)
   * * `StandardProduct.sales_volume` - StandardProduct - sales_volume - объем продаж
   * * `StandardProduct.volume_unit` - StandardProduct - volume_unit - Единица измерения
   * * `StandardProduct.variant` - StandardProduct - variant - variant
   * * `StandardProduct.sales_duration` - StandardProduct - sales_duration - Продолжительность продаж, лет
   * * `StandardProduct.annual_growth_rate` - StandardProduct - annual_growth_rate - Годовой темп роста, %
   * * `AdvancedProduct.id` - AdvancedProduct - id - ID
   * * `AdvancedProduct.is_blocked` - AdvancedProduct - is_blocked - Объект заблокирован из-за недостаточно высокого тарифа
   * * `AdvancedProduct.name` - AdvancedProduct - name - Название продукта
   * * `AdvancedProduct.start_date` - AdvancedProduct - start_date - Дата начала продаж
   * * `AdvancedProduct.group` - AdvancedProduct - group - group
   * * `AdvancedProduct.use_lead_generation` - AdvancedProduct - use_lead_generation - Использовать лидогенерацию
   * * `AdvancedProduct.potential_market_size` - AdvancedProduct - potential_market_size - Потенциальный объём рынка (PAM)
   * * `AdvancedProduct.quantity_pam` - AdvancedProduct - quantity_pam - Количество PAM, шт.
   * * `AdvancedProduct.tam_pam` - AdvancedProduct - tam_pam - TAM/PAM, %)
   * * `AdvancedProduct.total_target_market` - AdvancedProduct - total_target_market - Общий объём целевого рынка (TAM)
   * * `AdvancedProduct.quantity_tam` - AdvancedProduct - quantity_tam - Количество TAM, шт.
   * * `AdvancedProduct.sam_tam` - AdvancedProduct - sam_tam - SAM/TAM, %)
   * * `AdvancedProduct.available_market_size` - AdvancedProduct - available_market_size - Доступный объём рынка (SAM)
   * * `AdvancedProduct.quantity_sam` - AdvancedProduct - quantity_sam - Количество SAM, шт.
   * * `AdvancedProduct.call_conversion` - AdvancedProduct - call_conversion - Конверсия обращений, %)
   * * `AdvancedProduct.purchase_conversion` - AdvancedProduct - purchase_conversion - Конверсия покупок, %)
   * * `AdvancedProduct.round_values_to_integer` - AdvancedProduct - round_values_to_integer - Округлять значения до целого
   * * `AdvancedProduct.price` - AdvancedProduct - price - Цена с НДС, руб/шт
   * * `AdvancedProduct.tax_rate` - AdvancedProduct - tax_rate - Налоговая ставка
   * * `AdvancedProduct.sales_volume` - AdvancedProduct - sales_volume - объем продаж
   * * `AdvancedProduct.volume_unit` - AdvancedProduct - volume_unit - Единица измерения
   * * `AdvancedProduct.variant` - AdvancedProduct - variant - variant
   * * `AdvancedProduct.end_date` - AdvancedProduct - end_date - Дата окончания продаж
   * * `AdvancedProduct.volume_indexing` - AdvancedProduct - volume_indexing - Индексация объема
   * * `AdvancedProduct.volume_indexing_frequency` - AdvancedProduct - volume_indexing_frequency - Период индексации объема
   * * `AdvancedProduct.price_sensitivity_coefficient` - AdvancedProduct - price_sensitivity_coefficient - Коэф. чувствительности к цене
   * * `AdvancedProduct.annual_inflation` - AdvancedProduct - annual_inflation - Индексация цены
   * * `AdvancedProduct.price_indexing_frequency` - AdvancedProduct - price_indexing_frequency - Период индексации цены
   * * `AdvancedProduct.price_coeff` - AdvancedProduct - price_coeff - месячные коэффициенты цены
   * * `AdvancedProduct.use_price_coeff` - AdvancedProduct - use_price_coeff - Использовать коэфф-ы цены
   * * `AdvancedProduct.price_coeff_for_all_products` - AdvancedProduct - price_coeff_for_all_products - Использовать коэфф. цены для всех продуктов
   * * `AdvancedProduct.volume_coeff` - AdvancedProduct - volume_coeff - Квартальные коэффициенты объема
   * * `AdvancedProduct.use_volume_coeff` - AdvancedProduct - use_volume_coeff - Использовать коэфф-ы объема
   * * `AdvancedProduct.volume_coeff_for_all_products` - AdvancedProduct - volume_coeff_for_all_products - Использовать коэфф. объема для всех продуктов
   * * `AdvancedProduct.use_taxes` - AdvancedProduct - use_taxes - Использовать налоги на продукт
   * * `AdvancedProduct.subject_to_ndpi` - AdvancedProduct - subject_to_ndpi - Облагается НДПИ
   * * `AdvancedProduct.subject_to_excise_duty` - AdvancedProduct - subject_to_excise_duty - Облагается акцизом
   * * `TabularProduct.id` - TabularProduct - id - ID
   * * `TabularProduct.name` - TabularProduct - name - Название продукта
   * * `TabularProduct.variant` - TabularProduct - variant - variant
   * * `TabularProduct.date_row_number` - TabularProduct - date_row_number - Номер колонки поля даты
   * * `TabularProduct.price_row_number` - TabularProduct - price_row_number - Номер колонки поля цены
   * * `TabularProduct.volume_row_number` - TabularProduct - volume_row_number - Номер колонки поля объёма
   * * `TabularProduct.revenue_with_vat_row_number` - TabularProduct - revenue_with_vat_row_number - Номер колонки поля налогов с НДС
   * * `TabularProduct.vat_row_number` - TabularProduct - vat_row_number - Номер колонки поля налогов
   * * `TabularProduct.revenue_without_vat_row_number` - TabularProduct - revenue_without_vat_row_number - Номер колонки поля налогов без НДС
   * * `TabularProduct.excise_row_number` - TabularProduct - excise_row_number - Номер колонки поля акцизов
   * * `TabularProduct.ndpi_row_number` - TabularProduct - ndpi_row_number - Номер колонки поля НДПИ
   * * `TabularProductData.id` - TabularProductData - id - ID
   * * `TabularProductData.product` - TabularProductData - product - product
   * * `TabularProductData.date` - TabularProductData - date - Дата
   * * `TabularProductData.price` - TabularProductData - price - Цена с НДС
   * * `TabularProductData.volume` - TabularProductData - volume - Объём
   * * `TabularProductData.revenue_with_vat` - TabularProductData - revenue_with_vat - Выручка с НДС
   * * `TabularProductData.vat` - TabularProductData - vat - НДС с выручки
   * * `TabularProductData.revenue_without_vat` - TabularProductData - revenue_without_vat - Выручка без НДС
   * * `TabularProductData.excise` - TabularProductData - excise - Акциз
   * * `TabularProductData.ndpi` - TabularProductData - ndpi - НДПИ
   * * `StandartProductConversionField.id` - StandartProductConversionField - id - ID
   * * `StandartProductConversionField.product` - StandartProductConversionField - product - product
   * * `StandartProductConversionField.name` - StandartProductConversionField - name - Название конверсии
   * * `StandartProductConversionField.value` - StandartProductConversionField - value - Значение конверсии
   * * `AdvancedProductConversionField.id` - AdvancedProductConversionField - id - ID
   * * `AdvancedProductConversionField.product` - AdvancedProductConversionField - product - product
   * * `AdvancedProductConversionField.name` - AdvancedProductConversionField - name - Название конверсии
   * * `AdvancedProductConversionField.value` - AdvancedProductConversionField - value - Значение конверсии
   * * `OpexVariant.id` - OpexVariant - id - ID
   * * `OpexVariant.is_blocked` - OpexVariant - is_blocked - Объект заблокирован из-за недостаточно высокого тарифа
   * * `OpexVariant.project` - OpexVariant - project - project
   * * `OpexVariant.variant_name` - OpexVariant - variant_name - variant name
   * * `OpexVariant.product_varinat` - OpexVariant - product_varinat - product varinat
   * * `OpexsGroup.id` - OpexsGroup - id - ID
   * * `OpexsGroup.name` - OpexsGroup - name - Название группы
   * * `Opex.id` - Opex - id - ID
   * * `Opex.is_blocked` - Opex - is_blocked - Объект заблокирован из-за недостаточно высокого тарифа
   * * `Opex.group` - Opex - group - group
   * * `Opex.variant` - Opex - variant - variant
   * * `Opex.product_type` - Opex - product_type - product type
   * * `Opex.product_id` - Opex - product_id - product id
   * * `Opex.name` - Opex - name - название расхода
   * * `Opex.cost_types_by_economic_grouping` - Opex - cost_types_by_economic_grouping - Выбор типа затрат по экономической группировке
   * * `Opex.unit` - Opex - unit - Применяемая единица измерения
   * * `Opex.start_date` - Opex - start_date - Дата начала расхода
   * * `Opex.end_date` - Opex - end_date - Дата окончания расхода
   * * `Opex.one_time_opex` - Opex - one_time_opex - Единовременный расход
   * * `Opex.opex_date` - Opex - opex_date - Дата расхода
   * * `Opex.types_business_activity_costs` - Opex - types_business_activity_costs - Выбор типа затрат по деловой активности
   * * `Opex.quantity_opexs` - Opex - quantity_opexs - количество затрат
   * * `Opex.tax` - Opex - tax - Идентификатор налогового платежа в составе расходов
   * * `Opex.type_tax` - Opex - type_tax - Включать расход в расчет налога на прибыль
   * * `Opex.price` - Opex - price - Сумма с НДС в месяц, рублей
   * * `Opex.production_volume` - Opex - production_volume - объем продукции
   * * `Opex.VAT_rate` - Opex - VAT_rate - Ставка НДС
   * * `Opex.price_indexation` - Opex - price_indexation - Индексация закупочной цены по продажам
   * * `Opex.create_date` - Opex - create_date - create date
   * * `SpreadsheetConfig.id` - SpreadsheetConfig - id - ID
   * * `SpreadsheetConfig.product` - SpreadsheetConfig - product - product
   * * `SpreadsheetConfig.config` - SpreadsheetConfig - config - config
   * * `ActualSale.id` - ActualSale - id - ID
   * * `ActualSale.scenario` - ActualSale - scenario - scenario
   * * `ActualSale.created_by` - ActualSale - created_by - created by
   * * `ActualSale.planning_object_id` - ActualSale - planning_object_id - planning object id
   * * `ActualSale.source` - ActualSale - source - source
   * * `ActualSale.source_system` - ActualSale - source_system - source system
   * * `ActualSale.external_id` - ActualSale - external_id - external id
   * * `ActualSale.raw_payload` - ActualSale - raw_payload - raw payload
   * * `ActualSale.import_batch` - ActualSale - import_batch - import batch
   * * `ActualSale.created_at` - ActualSale - created_at - created at
   * * `ActualSale.updated_at` - ActualSale - updated_at - updated at
   * * `ActualSale.date` - ActualSale - date - Дата
   * * `ActualSale.product_name` - ActualSale - product_name - Название продукта
   * * `ActualSale.volume` - ActualSale - volume - Объем продаж
   * * `ActualSale.amount` - ActualSale - amount - Цена за единицу (с НДС)
   * * `ActualSale.vat_rate` - ActualSale - vat_rate - НДС
   * * `ActualSale.description` - ActualSale - description - Описание
   * * `ImportBatch.id` - ImportBatch - id - ID
   * * `ImportBatch.source` - ImportBatch - source - source
   * * `ImportBatch.source_system` - ImportBatch - source_system - source system
   * * `ImportBatch.status` - ImportBatch - status - status
   * * `ImportBatch.created_by` - ImportBatch - created_by - created by
   * * `ImportBatch.raw_payload` - ImportBatch - raw_payload - raw payload
   * * `ImportBatch.error_report` - ImportBatch - error_report - error report
   * * `ImportBatch.total_rows` - ImportBatch - total_rows - total rows
   * * `ImportBatch.valid_rows` - ImportBatch - valid_rows - valid rows
   * * `ImportBatch.error_rows` - ImportBatch - error_rows - error rows
   * * `ImportBatch.created_at` - ImportBatch - created_at - created at
   * * `ImportBatch.updated_at` - ImportBatch - updated_at - updated at
   * * `ImportBatchRow.id` - ImportBatchRow - id - ID
   * * `ImportBatchRow.batch` - ImportBatchRow - batch - batch
   * * `ImportBatchRow.row_number` - ImportBatchRow - row_number - row number
   * * `ImportBatchRow.raw_data` - ImportBatchRow - raw_data - raw data
   * * `ImportBatchRow.normalized_data` - ImportBatchRow - normalized_data - normalized data
   * * `ImportBatchRow.errors` - ImportBatchRow - errors - errors
   * * `ImportBatchRow.target_model` - ImportBatchRow - target_model - target model
   * * `ImportBatchRow.target_object_id` - ImportBatchRow - target_object_id - target object id
   * * `ImportBatchRow.created_at` - ImportBatchRow - created_at - created at
   * * `ScenarioSettings.id` - ScenarioSettings - id - ID
   * * `ScenarioSettings.scenario` - ScenarioSettings - scenario - scenario
   * * `ScenarioSettings.financial_data_changed` - ScenarioSettings - financial_data_changed - Финансовые данные были изменены после последнего расчета
   * * `ScenarioSettings.updated_at` - ScenarioSettings - updated_at - updated at
   * * `PnLStatement.id` - PnLStatement - id - ID
   * * `PnLStatement.scenario` - PnLStatement - scenario - scenario
   * * `PnLStatement.date` - PnLStatement - date - Дата
   * * `PnLStatement.revenue` - PnLStatement - revenue - Выручка
   * * `PnLStatement.cost_price` - PnLStatement - cost_price - Себестоимость
   * * `PnLStatement.variables_opexs` - PnLStatement - variables_opexs - Переменные расходы
   * * `PnLStatement.fixed_opexs` - PnLStatement - fixed_opexs - Постоянные расходы
   * * `PnLStatement.gross_profit` - PnLStatement - gross_profit - Валовая прибыль
   * * `PnLStatement.business_expenses` - PnLStatement - business_expenses - Коммерческие расходы
   * * `PnLStatement.management_expenses` - PnLStatement - management_expenses - Управленческие расходы
   * * `PnLStatement.operating_income_ebit` - PnLStatement - operating_income_ebit - Операционная прибыль EBIT
   * * `PnLStatement.interest_expenses` - PnLStatement - interest_expenses - Процентные расходы
   * * `PnLStatement.profit_before_tax` - PnLStatement - profit_before_tax - Прибыль до налогообложения
   * * `PnLStatement.income_tax` - PnLStatement - income_tax - Налог на прибыль
   * * `PnLStatement.net_profit` - PnLStatement - net_profit - Чистая прибыль
   * * `PnLStatement.ebitda` - PnLStatement - ebitda - EBITDA
   * * `CashFlowStatement.id` - CashFlowStatement - id - ID
   * * `CashFlowStatement.scenario` - CashFlowStatement - scenario - scenario
   * * `CashFlowStatement.date` - CashFlowStatement - date - Дата
   * * `CashFlowStatement.ebitda` - CashFlowStatement - ebitda - EBITDA
   * * `CashFlowStatement.working_weight_change` - CashFlowStatement - working_weight_change - Изменение рабочего капитала
   * * `CashFlowStatement.income_tax` - CashFlowStatement - income_tax - Налог на прибыль
   * * `CashFlowStatement.net_cash_flow_from_operations` - CashFlowStatement - net_cash_flow_from_operations - Чистый денежный поток по операционной деятельности
   * * `CashFlowStatement.payment_capital_costs` - CashFlowStatement - payment_capital_costs - Оплата капитальных расходов
   * * `CashFlowStatement.vat_refund` - CashFlowStatement - vat_refund - Возмещение НДС
   * * `CashFlowStatement.payment_liquidation_expenses` - CashFlowStatement - payment_liquidation_expenses - Оплата ликвидационных расходов
   * * `CashFlowStatement.receipt_liquidation_proceeds` - CashFlowStatement - receipt_liquidation_proceeds - Поступление ликвидационных доходов
   * * `CashFlowStatement.net_cash_flow_from_investing_activities` - CashFlowStatement - net_cash_flow_from_investing_activities - Чистый денежный поток по инвестиционной деятельности
   * * `CashFlowStatement.receipt_from_owners` - CashFlowStatement - receipt_from_owners - Поступление от собственников
   * * `CashFlowStatement.credit_receipt` - CashFlowStatement - credit_receipt - Поступление кредита
   * * `CashFlowStatement.return_credits` - CashFlowStatement - return_credits - Возврат кредитов
   * * `CashFlowStatement.interest_payment` - CashFlowStatement - interest_payment - Оплата процентов
   * * `CashFlowStatement.net_cash_flow_from_financing_activities` - CashFlowStatement - net_cash_flow_from_financing_activities - Чистый денежный поток по финансовой деятельности
   * * `CashFlowStatement.net_cash_flow` - CashFlowStatement - net_cash_flow - Чистый денежный поток
   * * `CashFlowStatement.cash_balance_beginning_period` - CashFlowStatement - cash_balance_beginning_period - Остаток денежных средств на начало периода
   * * `CashFlowStatement.cash_balance_the_end_period` - CashFlowStatement - cash_balance_the_end_period - Остаток денежных средств на конец периода
   * * `Balance.id` - Balance - id - ID
   * * `Balance.scenario` - Balance - scenario - scenario
   * * `Balance.date` - Balance - date - Дата
   * * `Balance.fixed_assets` - Balance - fixed_assets - Основные средства
   * * `Balance.total_non_current_assets` - Balance - total_non_current_assets - Итого внеоборотные активы
   * * `Balance.stocks` - Balance - stocks - Запасы
   * * `Balance.vat_purchased_assets` - Balance - vat_purchased_assets - НДС по приобретенным ценностям
   * * `Balance.accounts_receivable` - Balance - accounts_receivable - Дебиторская задолженность
   * * `Balance.cash` - Balance - cash - Денежные средства
   * * `Balance.total_current_assets` - Balance - total_current_assets - Итого оборотные активы
   * * `Balance.total_balance` - Balance - total_balance - Итого баланс
   * * `Balance.authorized_share_capital` - Balance - authorized_share_capital - Уставный (акционерный) капитал
   * * `Balance.undestributed_profits` - Balance - undestributed_profits - Нераспределенная прибыль
   * * `Balance.total_equity` - Balance - total_equity - Итого собственный капитал
   * * `Balance.borrowed_funds` - Balance - borrowed_funds - Заемные средства
   * * `Balance.accounts_payable` - Balance - accounts_payable - Кредиторская задолженность
   * * `Balance.total_liabilities` - Balance - total_liabilities - Итого обязательства
   * * `Balance.total_balance2` - Balance - total_balance2 - Итого баланс
   * * `Coefficients.id` - Coefficients - id - ID
   * * `Coefficients.scenario` - Coefficients - scenario - scenario
   * * `Coefficients.date` - Coefficients - date - Дата
   * * `Coefficients.return_on_sales_rot` - Coefficients - return_on_sales_rot - Рентабельность продаж (ROS)
   * * `Coefficients.return_on_equity_roe` - Coefficients - return_on_equity_roe - Рентабельность собственного капитала (ROE)
   * * `Coefficients.return_on_assets_roa` - Coefficients - return_on_assets_roa - Рентабельность активов (ROA)
   * * `Coefficients.asset_turnover_ratio` - Coefficients - asset_turnover_ratio - Коэффициент оборачиваемости активов
   * * `Coefficients.current_assets_turnover_ratio` - Coefficients - current_assets_turnover_ratio - Коэффициент оборачиваемости оборотных активов
   * * `Coefficients.inventory_turnover_ratio` - Coefficients - inventory_turnover_ratio - Коэффициент оборачиваемости запасов
   * * `Coefficients.accounts_receivable_turnover_ratio` - Coefficients - accounts_receivable_turnover_ratio - Коэффициент оборачиваемости дебиторской задолженности
   * * `Coefficients.accounts_payable_turnover_ratio` - Coefficients - accounts_payable_turnover_ratio - Коэффициент оборачиваемости кредиторской задолженности
   * * `Coefficients.autonomy_coefficient` - Coefficients - autonomy_coefficient - Коэффициент автономии
   * * `Coefficients.leverage_ratio_de` - Coefficients - leverage_ratio_de - Коэффициент левериджа (D/E)
   * * `Coefficients.own_working_capital_ratio` - Coefficients - own_working_capital_ratio - Коэффициент собственных оборотных средств
   * * `Coefficients.absolute_liquidity_ratio` - Coefficients - absolute_liquidity_ratio - Коэффициент абсолютной ликвидности
   * * `Coefficients.interim_liquidity_ratio` - Coefficients - interim_liquidity_ratio - Коэффициент промежуточной ликвидности
   * * `Coefficients.current_liquidity_ratio` - Coefficients - current_liquidity_ratio - Коэффициент текущей ликвидности
   * * `Feedback.id` - Feedback - id - ID
   * * `Feedback.user` - Feedback - user - Автор фидбека
   * * `Feedback.feedback_type` - Feedback - feedback_type - Тип
   * * `Feedback.rating` - Feedback - rating - Оценка продукта
   * * `Feedback.feedback_text` - Feedback - feedback_text - Текст
   * * `Scenario.id` - Scenario - id - ID
   * * `Scenario.is_blocked` - Scenario - is_blocked - Объект заблокирован из-за недостаточно высокого тарифа
   * * `Scenario.project` - Scenario - project - project
   * * `Scenario.name` - Scenario - name - Наименование сценария
   * * `Scenario.desc` - Scenario - desc - Краткое описание
   * * `Scenario.variant_sales` - Scenario - variant_sales - Продажи
   * * `Scenario.variant_opexs` - Scenario - variant_opexs - Затраты
   * * `Scenario.variant_capex` - Scenario - variant_capex - Капитальные расходы
   * * `Scenario.variant_taxs` - Scenario - variant_taxs - Налоги проекта
   * * `Scenario.variant_discount_rate` - Scenario - variant_discount_rate - Ставка дисконтирования
   * * `Scenario.variant_own_funds` - Scenario - variant_own_funds - Собственный капитал
   * * `Scenario.variant_credits` - Scenario - variant_credits - Банковский кредит
   * * `Scenario.variant_leasing` - Scenario - variant_leasing - Лизинг
   * * `Scenario.variant_wk` - Scenario - variant_wk - Рабочий капитал
   * * `Scenario.is_public` - Scenario - is_public - Является общедоступным
   * * `Scenario.variant_venture_funds` - Scenario - variant_venture_funds - Вариант венчурного фонда
   * * `Scenario.calculation_data` - Scenario - calculation_data - Дата последнего расчета
   * * `Scenario.needs_recalculation` - Scenario - needs_recalculation - Требуется перерасчет
   * * `TamSamPamSomChart.id` - TamSamPamSomChart - id - ID
   * * `TamSamPamSomChart.scenario` - TamSamPamSomChart - scenario - scenario
   * * `TamSamPamSomChart.product_id` - TamSamPamSomChart - product_id - id продукта
   * * `TamSamPamSomChart.product_name` - TamSamPamSomChart - product_name - Имя продукта
   * * `TamSamPamSomChart.pam` - TamSamPamSomChart - pam - Потенциальный объем рынка
   * * `TamSamPamSomChart.tam` - TamSamPamSomChart - tam - Общий объем целевого рынка
   * * `TamSamPamSomChart.sam` - TamSamPamSomChart - sam - Доступный объем рынка
   * * `TamSamPamSomChart.som` - TamSamPamSomChart - som - Объем продаж в месяц
   * * `ProfitAndLossPlan.id` - ProfitAndLossPlan - id - ID
   * * `ProfitAndLossPlan.scenario` - ProfitAndLossPlan - scenario - scenario
   * * `ProfitAndLossPlan.date` - ProfitAndLossPlan - date - Дата
   * * `ProfitAndLossPlan.revenue` - ProfitAndLossPlan - revenue - Выручка
   * * `ProfitAndLossPlan.cost_price` - ProfitAndLossPlan - cost_price - Себестоимость
   * * `ProfitAndLossPlan.variables_opexs` - ProfitAndLossPlan - variables_opexs - Переменные расходы
   * * `ProfitAndLossPlan.fixed_opexs` - ProfitAndLossPlan - fixed_opexs - Постоянные расходы
   * * `ProfitAndLossPlan.gross_profit` - ProfitAndLossPlan - gross_profit - Валовая прибыль
   * * `ProfitAndLossPlan.business_expenses` - ProfitAndLossPlan - business_expenses - Коммерческие расходы
   * * `ProfitAndLossPlan.management_expenses` - ProfitAndLossPlan - management_expenses - Управленческие расходы
   * * `ProfitAndLossPlan.operating_income_ebit` - ProfitAndLossPlan - operating_income_ebit - Операционная прибыль EBIT
   * * `ProfitAndLossPlan.interest_expenses` - ProfitAndLossPlan - interest_expenses - Процентные расходы
   * * `ProfitAndLossPlan.profit_before_tax` - ProfitAndLossPlan - profit_before_tax - Прибыль до налогообложения
   * * `ProfitAndLossPlan.income_tax` - ProfitAndLossPlan - income_tax - Налог на прибыль
   * * `ProfitAndLossPlan.net_profit` - ProfitAndLossPlan - net_profit - Чистая прибыль
   * * `ProfitAndLossPlan.ebitda` - ProfitAndLossPlan - ebitda - EBITDA
   * * `ProfitAndLossPlan.ebit_to_interest` - ProfitAndLossPlan - ebit_to_interest - ебит к процентам
   * * `SalesProductPlan.id` - SalesProductPlan - id - ID
   * * `SalesProductPlan.scenario` - SalesProductPlan - scenario - scenario
   * * `SalesProductPlan.product_id` - SalesProductPlan - product_id - id продукта
   * * `SalesProductPlan.product_name` - SalesProductPlan - product_name - Имя продукта
   * * `SalesProductPlan.date` - SalesProductPlan - date - Дата
   * * `SalesProductPlan.price` - SalesProductPlan - price - Цена
   * * `SalesProductPlan.volume` - SalesProductPlan - volume - Объем
   * * `SalesProductPlan.revenue_with_vat` - SalesProductPlan - revenue_with_vat - Выручка с НДС
   * * `SalesProductPlan.vat` - SalesProductPlan - vat - НДС
   * * `SalesProductPlan.revenue_without_vat` - SalesProductPlan - revenue_without_vat - Выручка без НДС
   * * `TotalSalesPlan.id` - TotalSalesPlan - id - ID
   * * `TotalSalesPlan.scenario` - TotalSalesPlan - scenario - scenario
   * * `TotalSalesPlan.date` - TotalSalesPlan - date - Дата
   * * `TotalSalesPlan.price` - TotalSalesPlan - price - Итого цена
   * * `TotalSalesPlan.volume` - TotalSalesPlan - volume - Итого объем
   * * `TotalSalesPlan.revenue_with_vat` - TotalSalesPlan - revenue_with_vat - итого выручка с НДС
   * * `TotalSalesPlan.vat` - TotalSalesPlan - vat - Итого НДС
   * * `TotalSalesPlan.revenue_without_vat` - TotalSalesPlan - revenue_without_vat - Итого выручка без НДС
   * * `CashFlowPlan.id` - CashFlowPlan - id - ID
   * * `CashFlowPlan.scenario` - CashFlowPlan - scenario - scenario
   * * `CashFlowPlan.date` - CashFlowPlan - date - Дата
   * * `CashFlowPlan.ebitda` - CashFlowPlan - ebitda - EBITDA
   * * `CashFlowPlan.working_weight_change` - CashFlowPlan - working_weight_change - Изменение рабочего капитала
   * * `CashFlowPlan.income_tax` - CashFlowPlan - income_tax - Налог на прибыль
   * * `CashFlowPlan.net_cash_flow_from_operations` - CashFlowPlan - net_cash_flow_from_operations - Чистый денежный поток по операционной деятельности
   * * `CashFlowPlan.payment_capital_costs` - CashFlowPlan - payment_capital_costs - Оплата капитальных расходов
   * * `CashFlowPlan.vat_refund` - CashFlowPlan - vat_refund - Возмещение НДС
   * * `CashFlowPlan.payment_liquidation_expenses` - CashFlowPlan - payment_liquidation_expenses - Оплата ликвидационных расходов
   * * `CashFlowPlan.receipt_liquidation_proceeds` - CashFlowPlan - receipt_liquidation_proceeds - Поступление ликвидационных доходов
   * * `CashFlowPlan.net_cash_flow_from_investing_activities` - CashFlowPlan - net_cash_flow_from_investing_activities - Чистый денежный поток по инвестиционной деятельности
   * * `CashFlowPlan.receipt_from_owners` - CashFlowPlan - receipt_from_owners - Поступление от собственников
   * * `CashFlowPlan.incoming_from_investors` - CashFlowPlan - incoming_from_investors - Поступление от инвесторов
   * * `CashFlowPlan.payments_to_investors` - CashFlowPlan - payments_to_investors - Выплаты инвесторам
   * * `CashFlowPlan.dividends_payment` - CashFlowPlan - dividends_payment - Выплаты дивидендов
   * * `CashFlowPlan.credit_receipt` - CashFlowPlan - credit_receipt - Поступление кредита
   * * `CashFlowPlan.return_credits` - CashFlowPlan - return_credits - Возврат кредитов
   * * `CashFlowPlan.interest_payment` - CashFlowPlan - interest_payment - Оплата процентов
   * * `CashFlowPlan.net_cash_flow_from_financing_activities` - CashFlowPlan - net_cash_flow_from_financing_activities - Чистый денежный поток по финансовой деятельности
   * * `CashFlowPlan.net_cash_flow` - CashFlowPlan - net_cash_flow - Чистый денежный поток
   * * `CashFlowPlan.cash_balance_beginning_period` - CashFlowPlan - cash_balance_beginning_period - Остаток денежных средств на начало периода
   * * `CashFlowPlan.cash_balance_the_end_period` - CashFlowPlan - cash_balance_the_end_period - Остаток денежных средств на конец периода
   * * `Balance.id` - Balance - id - ID
   * * `Balance.scenario` - Balance - scenario - scenario
   * * `Balance.date` - Balance - date - Дата
   * * `Balance.fixed_assets` - Balance - fixed_assets - Основные средства
   * * `Balance.total_non_current_assets` - Balance - total_non_current_assets - Итого внеоборотные активы
   * * `Balance.stocks` - Balance - stocks - Запасы
   * * `Balance.investor_funds` - Balance - investor_funds - Средства инвестора
   * * `Balance.intangible_assets` - Balance - intangible_assets - Нематериальные активы
   * * `Balance.vat_purchased_assets` - Balance - vat_purchased_assets - НДС по приобретенным ценностям
   * * `Balance.accounts_receivable` - Balance - accounts_receivable - Дебиторская задолженность
   * * `Balance.cash` - Balance - cash - Денежные средства
   * * `Balance.total_current_assets` - Balance - total_current_assets - Итого оборотные активы
   * * `Balance.total_balance` - Balance - total_balance - Итого баланс
   * * `Balance.authorized_share_capital` - Balance - authorized_share_capital - Уставный (акционерный) капитал
   * * `Balance.undestributed_profits` - Balance - undestributed_profits - Нераспределенная прибыль
   * * `Balance.total_equity` - Balance - total_equity - Итого собственный капитал
   * * `Balance.borrowed_funds` - Balance - borrowed_funds - Заемные средства
   * * `Balance.accounts_payable` - Balance - accounts_payable - Кредиторская задолженность
   * * `Balance.total_liabilities` - Balance - total_liabilities - Итого обязательства
   * * `Balance.total_balance2` - Balance - total_balance2 - Итого баланc
   * * `ResultFinancialAnalys.id` - ResultFinancialAnalys - id - ID
   * * `ResultFinancialAnalys.scenario` - ResultFinancialAnalys - scenario - scenario
   * * `ResultFinancialAnalys.date` - ResultFinancialAnalys - date - Дата
   * * `ResultFinancialAnalys.return_on_sales_rot` - ResultFinancialAnalys - return_on_sales_rot - Рентабельность продаж (ROS)
   * * `ResultFinancialAnalys.return_on_equity_roe` - ResultFinancialAnalys - return_on_equity_roe - Рентабельность собственного капитала (ROE)
   * * `ResultFinancialAnalys.return_on_assets_roa` - ResultFinancialAnalys - return_on_assets_roa - Рентабельность активов (ROA)
   * * `ResultFinancialAnalys.asset_turnover_ratio` - ResultFinancialAnalys - asset_turnover_ratio - Коэффициент оборачиваемости активов
   * * `ResultFinancialAnalys.current_assets_turnover_ratio` - ResultFinancialAnalys - current_assets_turnover_ratio - Коэффициент оборачиваемости оборотных активов
   * * `ResultFinancialAnalys.inventory_turnover_ratio` - ResultFinancialAnalys - inventory_turnover_ratio - Коэффициент оборачиваемости запасов
   * * `ResultFinancialAnalys.accounts_receivable_turnover_ratio` - ResultFinancialAnalys - accounts_receivable_turnover_ratio - Коэффициент оборачиваемости дебиторской задолженности
   * * `ResultFinancialAnalys.accounts_payable_turnover_ratio` - ResultFinancialAnalys - accounts_payable_turnover_ratio - Коэффициент оборачиваемости кредиторской задолженности
   * * `ResultFinancialAnalys.autonomy_coefficient` - ResultFinancialAnalys - autonomy_coefficient - Коэффициент автономии
   * * `ResultFinancialAnalys.leverage_ratio_de` - ResultFinancialAnalys - leverage_ratio_de - Коэффициент левериджа (D/E)
   * * `ResultFinancialAnalys.own_working_capital_ratio` - ResultFinancialAnalys - own_working_capital_ratio - Коэффициент собственных оборотных средств
   * * `ResultFinancialAnalys.absolute_liquidity_ratio` - ResultFinancialAnalys - absolute_liquidity_ratio - Коэффициент абсолютной ликвидности
   * * `ResultFinancialAnalys.interim_liquidity_ratio` - ResultFinancialAnalys - interim_liquidity_ratio - Коэффициент промежуточной ликвидности
   * * `ResultFinancialAnalys.current_liquidity_ratio` - ResultFinancialAnalys - current_liquidity_ratio - Коэффициент текущей ликвидности
   * * `ResultFinancialAnalys.debt_to_ebitda` - ResultFinancialAnalys - debt_to_ebitda - долг к ебитда
   * * `InvestorReport.id` - InvestorReport - id - ID
   * * `InvestorReport.scenario` - InvestorReport - scenario - scenario
   * * `InvestorReport.date` - InvestorReport - date - Дата
   * * `InvestorReport.venture_fund_name` - InvestorReport - venture_fund_name - Имя венчурного фонда
   * * `InvestorReport.venture_fund_id` - InvestorReport - venture_fund_id - ID венчурного фонда
   * * `InvestorReport.investment_amount` - InvestorReport - investment_amount - Сумма инвестирования
   * * `InvestorReport.dividends` - InvestorReport - dividends - Дивиденды
   * * `InvestorReport.cash_flow_payments` - InvestorReport - cash_flow_payments - Выплаты от денежного потока
   * * `InvestorReport.sales_payments` - InvestorReport - sales_payments - Выплаты от продаж
   * * `InvestorReport.fixed_sum_payments` - InvestorReport - fixed_sum_payments - Выплаты фиксированных сумм
   * * `InvestorReport.realization_payments` - InvestorReport - realization_payments - Выплаты от реализации
   * * `InvestorReport.loan_return` - InvestorReport - loan_return - Возврат займа
   * * `InvestorReport.loan_interests` - InvestorReport - loan_interests - Проценты по займам
   * * `InvestorReport.accumulated_financial_result` - InvestorReport - accumulated_financial_result - Накопленный финансовый результат
   * * `Rating.id` - Rating - id - ID
   * * `Rating.scenario` - Rating - scenario - scenario
   * * `Rating.rating` - Rating - rating - Рейтинг проекта
   * * `Rating.comment` - Rating - comment - Комментарий к рейтингу
   * * `Rating.comment_code` - Rating - comment_code - comment code
   * * `Rating.comment_params` - Rating - comment_params - comment params
   * * `MainParameter.id` - MainParameter - id - ID
   * * `MainParameter.scenario` - MainParameter - scenario - scenario
   * * `MainParameter.start_date` - MainParameter - start_date - Начало проекта
   * * `MainParameter.end_date` - MainParameter - end_date - Окончание проекта
   * * `FundingAmount.id` - FundingAmount - id - ID
   * * `FundingAmount.scenario` - FundingAmount - scenario - scenario
   * * `FundingAmount.capEx_amount` - FundingAmount - capEx_amount - Сумма CapEx (с НДС), руб
   * * `FundingAmount.amount_of_own_funds` - FundingAmount - amount_of_own_funds - Сумма собственных средств, руб
   * * `FundingAmount.amount_of_borrowed_funds` - FundingAmount - amount_of_borrowed_funds - Сумма заемных средств, руб
   * * `FundingAmount.DE_ratio` - FundingAmount - DE_ratio - Коэффициент D/E
   * * `FundingAmount.average_Debt_EBITDA_ratio` - FundingAmount - average_Debt_EBITDA_ratio - Средний коэффициент Debt/EBITDA
   * * `AnnualAverage.id` - AnnualAverage - id - ID
   * * `AnnualAverage.scenario` - AnnualAverage - scenario - scenario
   * * `AnnualAverage.average_annual_revenue` - AnnualAverage - average_annual_revenue - Среднегодовая выручка (без НДС), Руб
   * * `AnnualAverage.average_annual_operating_costs` - AnnualAverage - average_annual_operating_costs - Среднегодовые операционные затраты с амортизайцией (без НДС), руб
   * * `AnnualAverage.average_annual_net_profit` - AnnualAverage - average_annual_net_profit - Среднегодовая чистая прибыль, руб
   * * `AnnualAverage.average_return_on_sales` - AnnualAverage - average_return_on_sales - Средняя рентабельность продаж, %
   * * `AnnualAverage.average_annual_VAT` - AnnualAverage - average_annual_VAT - Среднегодовой НДС, руб
   * * `AnnualAverage.average_annual_income_tax` - AnnualAverage - average_annual_income_tax - Среднегодовой налог на прибыль, руб
   * * `BasicIndicator.id` - BasicIndicator - id - ID
   * * `BasicIndicator.scenario` - BasicIndicator - scenario - scenario
   * * `BasicIndicator.discount_rate` - BasicIndicator - discount_rate - ставка дисконтирования, %
   * * `BasicIndicator.refinancing_rate` - BasicIndicator - refinancing_rate - ставка рефинансирования, %
   * * `BasicIndicator.net_present_value_npv` - BasicIndicator - net_present_value_npv - чистая приведенная стоимость npv, руб
   * * `BasicIndicator.profitability_index_pi` - BasicIndicator - profitability_index_pi - индекс рентабельности pi
   * * `BasicIndicator.internal_rate_return_irr` - BasicIndicator - internal_rate_return_irr - внутренняя норма доходности irr, %
   * * `BasicIndicator.MIRR_internal_rate_return` - BasicIndicator - MIRR_internal_rate_return - Модифицированная внутренняя норма доходности MIRR, %
   * * `BasicIndicatorPeriodic.id` - BasicIndicatorPeriodic - id - ID
   * * `BasicIndicatorPeriodic.scenario` - BasicIndicatorPeriodic - scenario - scenario
   * * `BasicIndicatorPeriodic.date` - BasicIndicatorPeriodic - date - Дата
   * * `BasicIndicatorPeriodic.npv` - BasicIndicatorPeriodic - npv - чистая приведенная стоимость npv, руб
   * * `BasicIndicatorPeriodic.irr` - BasicIndicatorPeriodic - irr - внутренняя норма доходности irr, %
   * * `BasicIndicatorPeriodic.roi` - BasicIndicatorPeriodic - roi - рентабельность инвестиций roi, %
   * * `PaybackProject.id` - PaybackProject - id - ID
   * * `PaybackProject.scenario` - PaybackProject - scenario - scenario
   * * `PaybackProject.nominal_payback_period` - PaybackProject - nominal_payback_period - Номинальный срок окупаемости
   * * `PaybackProject.discounted_payback_period` - PaybackProject - discounted_payback_period - Дисконтированный срок окупаемости
   * * `PaybackProject.nominal_payback_parts` - PaybackProject - nominal_payback_parts - части номинального срока окупаемости
   * * `PaybackProject.discounted_payback_parts` - PaybackProject - discounted_payback_parts - части дисконтированного срока окупаемости
   * * `PaybackProject.nominal_payback_exists` - PaybackProject - nominal_payback_exists - номинальная окупаемость достигнута
   * * `PaybackProject.discounted_payback_exists` - PaybackProject - discounted_payback_exists - дисконтированная окупаемость достигнута
   * * `PaybackProject.nominal_payback_period_in_years` - PaybackProject - nominal_payback_period_in_years - срок окупаемости в годах
   * * `AllertOrError.id` - AllertOrError - id - ID
   * * `AllertOrError.scenario` - AllertOrError - scenario - scenario
   * * `AllertOrError.code` - AllertOrError - code - код сообщения
   * * `AllertOrError.type` - AllertOrError - type - тип сообщения
   * * `AllertOrError.text` - AllertOrError - text - текст сообщения
   * * `AllertOrError.params` - AllertOrError - params - параметры сообщения
   * * `LogEntry.id` - LogEntry - id - ID
   * * `LogEntry.user` - LogEntry - user - user
   * * `LogEntry.scenario` - LogEntry - scenario - scenario
   * * `LogEntry.project` - LogEntry - project - project
   * * `LogEntry.category` - LogEntry - category - Категория записи
   * * `LogEntry.timestamp` - LogEntry - timestamp - timestamp
   * * `LogEntry.message` - LogEntry - message - текст записи
   * * `Sphere.id` - Sphere - id - id
   * * `Sphere.name` - Sphere - name - Название
   * * `Sphere.locale` - Sphere - locale - locale
   * * `User.password` - User - password - пароль
   * * `User.last_login` - User - last_login - последний вход
   * * `User.is_superuser` - User - is_superuser - статус суперпользователя
   * * `User.id` - User - id - id
   * * `User.email` - User - email - email
   * * `User.first_name` - User - first_name - Имя
   * * `User.last_name` - User - last_name - Фамилия
   * * `User.patronymic` - User - patronymic - Отчество
   * * `User.phone_number` - User - phone_number - Номер телефона
   * * `User.sphere` - User - sphere - Сфера деятельности
   * * `User.create_date` - User - create_date - Дата создания юзера
   * * `User.user_type` - User - user_type - user type
   * * `User.position` - User - position - position
   * * `User.is_email_verified` - User - is_email_verified - is email verified
   * * `User.is_confirmation_sent` - User - is_confirmation_sent - is confirmation sent
   * * `User.is_active` - User - is_active - is active
   * * `User.is_staff` - User - is_staff - is staff
   * * `User.last_calculation_date` - User - last_calculation_date - last calculation date
   * * `User.ldap_uid` - User - ldap_uid - ldap uid
   * * `User.ldap_dn` - User - ldap_dn - ldap dn
   * * `User.pending_freeipa_password` - User - pending_freeipa_password - pending freeipa password
   * * `User.auth_source` - User - auth_source - auth source
   * * `User.last_ldap_sync_at` - User - last_ldap_sync_at - last ldap sync at
   * * `User.last_ldap_login_at` - User - last_ldap_login_at - last ldap login at
   * * `User.is_online` - User - is_online - В сети
   * * `User.is_onboarding_completed` - User - is_onboarding_completed - Прошел онбординг
   * * `User.groups` - User - groups - группы
   * * `User.user_permissions` - User - user_permissions - права пользователя
   * * `Company.id` - Company - id - ID
   * * `Company.name` - Company - name - name
   * * `Company.users` - Company - users - users
   * * `TermsServiceFile.id` - TermsServiceFile - id - ID
   * * `TermsServiceFile.file` - TermsServiceFile - file - file
   * * `TermsServiceFile.create_date` - TermsServiceFile - create_date - create date
   * * `PolicyConfFile.id` - PolicyConfFile - id - ID
   * * `PolicyConfFile.file` - PolicyConfFile - file - file
   * * `PolicyConfFile.create_date` - PolicyConfFile - create_date - create date
   * * `Requisites.id` - Requisites - id - id
   * * `Requisites.name` - Requisites - name - Название
   * * `Requisites.file` - Requisites - file - Файл
   * * `TariffPlan.id` - TariffPlan - id - id
   * * `TariffPlan.name` - TariffPlan - name - Название
   * * `TariffPlan.short_description` - TariffPlan - short_description - Короткое описание
   * * `TariffPlan.description` - TariffPlan - description - Описание
   * * `TariffPlan.is_for_investors` - TariffPlan - is_for_investors - Для инвесторов
   * * `TariffPlan.projects_create_limit` - TariffPlan - projects_create_limit - Макс. кол-во созданных проектов
   * * `TariffPlan.projects_storage_start_limit` - TariffPlan - projects_storage_start_limit - Хранение данных после начала тарифа
   * * `TariffPlan.projects_storage_finish_limit` - TariffPlan - projects_storage_finish_limit - Хранение данных после окончания тарифа (в днях)
   * * `TariffPlan.projects_invite_limit` - TariffPlan - projects_invite_limit - Макс. кол-во приглашенных пользователей на проекты
   * * `TariffPlan.active` - TariffPlan - active - active
   * * `TariffPermissions.id` - TariffPermissions - id - ID
   * * `TariffPermissions.tariff` - TariffPermissions - tariff - tariff
   * * `TariffPermissions.max_projects` - TariffPermissions - max_projects - максимум проектов
   * * `TariffPermissions.max_variants` - TariffPermissions - max_variants - Максимальное количество вариантов
   * * `TariffPermissions.max_products` - TariffPermissions - max_products - Максимум продуктов
   * * `TariffPermissions.max_capexs` - TariffPermissions - max_capexs - Максимум объектов кап. расходов
   * * `TariffPermissions.max_own_funds` - TariffPermissions - max_own_funds - Максимум взносов собст. капитала
   * * `TariffPermissions.max_opexs` - TariffPermissions - max_opexs - Максимум опексов
   * * `TariffPermissions.max_credits` - TariffPermissions - max_credits - Максимум кредитов
   * * `TariffPermissions.max_leasings` - TariffPermissions - max_leasings - Максимум лизингов
   * * `TariffPermissions.allowed_periods` - TariffPermissions - allowed_periods - allowed periods
   * * `TariffPermissions.max_variant_collections` - TariffPermissions - max_variant_collections - максимум сценариев
   * * `TariffPermissions.block_purshaces` - TariffPermissions - block_purshaces - блокировать рабочий капитал
   * * `TariffPermissions.block_leasings` - TariffPermissions - block_leasings - блокировать лизинги
   * * `TariffPermissions.block_special_modes` - TariffPermissions - block_special_modes - блокировать спец. режимы
   * * `TariffPermissions.block_advanced_products` - TariffPermissions - block_advanced_products - блокировать расширенные продукты
   * * `TariffPermissions.block_lead_generation` - TariffPermissions - block_lead_generation - блокировать лидогенерацию
   * * `TariffPermissions.max_sales_duration` - TariffPermissions - max_sales_duration - Максимальная длительность продаж
   * * `TariffPermissions.load_files` - TariffPermissions - load_files - Юзер может загружать файлы
   * * `TariffPermissions.view_rating` - TariffPermissions - view_rating - Юзер может просматривать рейтинг
   * * `TariffPermissions.income_tax_independent` - TariffPermissions - income_tax_independent - Разрешено отличие в налоговом учете амортизации
   * * `TariffPermissions.liquidation_expenses_and_income` - TariffPermissions - liquidation_expenses_and_income - Разрешены ликвидационные расходы и доходы
   * * `TariffPermissions.grace_period_credit` - TariffPermissions - grace_period_credit - разрешен расчет грейс-периодов для кредитов
   * * `TariffPermissions.credit_capitalization` - TariffPermissions - credit_capitalization - разрешена капитализация процентов по кредитам
   * * `TariffPermissions.block_distribution_ransom_payment` - TariffPermissions - block_distribution_ransom_payment - блокировать "распределение выкупного платежа"
   * * `TariffPermissions.block_sales_plan` - TariffPermissions - block_sales_plan - блокировать план продаж
   * * `TariffPermissions.block_schedule` - TariffPermissions - block_schedule - блокировать график там-сам-сом
   * * `TariffPermissions.max_loan_term` - TariffPermissions - max_loan_term - максимальный срок кредита
   * * `TariffPermissions.block_standard_taxes` - TariffPermissions - block_standard_taxes - блокировать стандартные налоги
   * * `TariffPermissions.balance_view` - TariffPermissions - balance_view - Разрешен просмотр баланса
   * * `TariffPermissions.financial_analysis_results` - TariffPermissions - financial_analysis_results - Разрешен просмотр результата фин. анализа
   * * `TariffPermissions.output_to_excel` - TariffPermissions - output_to_excel - Разрешен вывод в excel
   * * `TariffPermissions.vat_refund` - TariffPermissions - vat_refund - Разрешено возмещение НДС из бюджета
   * * `TariffPermissions.hard_taxs` - TariffPermissions - hard_taxs - Разрешены твердые налоги
   * * `TariffPermissions.project_shelf_life` - TariffPermissions - project_shelf_life - срок хранения проекта
   * * `PaymentPeriod.id` - PaymentPeriod - id - id
   * * `PaymentPeriod.tariff_plan` - PaymentPeriod - tariff_plan - tariff plan
   * * `PaymentPeriod.name` - PaymentPeriod - name - Название
   * * `PaymentPeriod.description` - PaymentPeriod - description - Описание
   * * `PaymentPeriod.period` - PaymentPeriod - period - Длительность подписки
   * * `PaymentPeriod.price` - PaymentPeriod - price - Цена
   * * `Payment.id` - Payment - id - id
   * * `Payment.payment_id` - Payment - payment_id - payment id
   * * `Payment.payment_method_id` - Payment - payment_method_id - payment method id
   * * `Payment.order_id` - Payment - order_id - order id
   * * `Payment.confirmation_url` - Payment - confirmation_url - confirmation url
   * * `Payment.user` - Payment - user - user
   * * `Payment.tariff_plan` - Payment - tariff_plan - tariff plan
   * * `Payment.payment_period` - Payment - payment_period - payment period
   * * `Payment.status` - Payment - status - status
   * * `Payment.created_at` - Payment - created_at - created at
   * * `Payment.updated_at` - Payment - updated_at - updated at
   * * `Subscription.uuid` - Subscription - uuid - uuid
   * * `Subscription.user` - Subscription - user - user
   * * `Subscription.tariff_plan` - Subscription - tariff_plan - tariff plan
   * * `Subscription.payment` - Subscription - payment - payment
   * * `Subscription.created_at` - Subscription - created_at - Дата создания
   * * `Subscription.ends_at` - Subscription - ends_at - Дата окончания
   * * `Subscription.active` - Subscription - active - active
   * * `Subscription.renewal` - Subscription - renewal - renewal
   * * `TariffPlanAfterVerify.id` - TariffPlanAfterVerify - id - id
   * * `TariffPlanAfterVerify.tariff_plan` - TariffPlanAfterVerify - tariff_plan - Тарифный план
   * * `TariffPlanAfterVerify.period` - TariffPlanAfterVerify - period - Длительность подписки
   * * `DiscountCoupon.id` - DiscountCoupon - id - ID
   * * `DiscountCoupon.code` - DiscountCoupon - code - Код
   * * `DiscountCoupon.discount` - DiscountCoupon - discount - Скидка
   * * `DiscountCoupon.valid_from` - DiscountCoupon - valid_from - Действует с
   * * `DiscountCoupon.valid_to` - DiscountCoupon - valid_to - Действует до
   * * `DiscountCoupon.active` - DiscountCoupon - active - Активен
   * * `DiscountCoupon.tariff_plans` - DiscountCoupon - tariff_plans - Тарифы, к которым можно использовать купон
   * * `Category.id` - Category - id - ID
   * * `Category.name` - Category - name - name
   * * `Category.nested_category` - Category - nested_category - nested category
   * * `Category.locale` - Category - locale - locale
   * * `Topic.id` - Topic - id - ID
   * * `Topic.category` - Topic - category - category
   * * `Topic.name` - Topic - name - Название темы
   * * `Topic.theory` - Topic - theory - HTML код теории
   * * `Topic.examples` - Topic - examples - HTML код примеров
   * * `Topic.locale` - Topic - locale - locale
   * * `TopicFile.id` - TopicFile - id - ID
   * * `TopicFile.name` - TopicFile - name - name
   * * `TopicFile.file` - TopicFile - file - file
   * * `Helper.id` - Helper - id - ID
   * * `Helper.field` - Helper - field - field
   * * `Helper.page` - Helper - page - page
   * * `Helper.text` - Helper - text - text
   * * `Helper.topic` - Helper - topic - topic
   * * `RolePreset.id` - RolePreset - id - ID
   * * `RolePreset.owner` - RolePreset - owner - Владелец пресета
   * * `RolePreset.name` - RolePreset - name - Название
   * * `RolePreset.description` - RolePreset - description - Описание
   * * `RolePreset.is_system` - RolePreset - is_system - Системная роль (read-only)
   * * `RolePreset.created_at` - RolePreset - created_at - created at
   * * `RolePreset.updated_at` - RolePreset - updated_at - updated at
   * * `RolePresetPermission.id` - RolePresetPermission - id - ID
   * * `RolePresetPermission.preset` - RolePresetPermission - preset - preset
   * * `RolePresetPermission.section` - RolePresetPermission - section - section
   * * `RolePresetPermission.action` - RolePresetPermission - action - action
   * * `RolePresetPermission.state` - RolePresetPermission - state - state
   * * `ProjectMembership.id` - ProjectMembership - id - ID
   * * `ProjectMembership.project` - ProjectMembership - project - project
   * * `ProjectMembership.user` - ProjectMembership - user - user
   * * `ProjectMembership.role` - ProjectMembership - role - Роль
   * * `ProjectMembership.preset` - ProjectMembership - preset - Пресет (только для guest)
   * * `ProjectMembership.status` - ProjectMembership - status - Статус
   * * `ProjectMembership.created_at` - ProjectMembership - created_at - created at
   * * `ProjectMembership.updated_at` - ProjectMembership - updated_at - updated at
   * * `MembershipPermissionOverride.id` - MembershipPermissionOverride - id - ID
   * * `MembershipPermissionOverride.membership` - MembershipPermissionOverride - membership - membership
   * * `MembershipPermissionOverride.section` - MembershipPermissionOverride - section - section
   * * `MembershipPermissionOverride.action` - MembershipPermissionOverride - action - action
   * * `MembershipPermissionOverride.state` - MembershipPermissionOverride - state - state
   * * `MembershipPermissionOverride.created_at` - MembershipPermissionOverride - created_at - created at
   * * `MembershipPermissionOverride.updated_at` - MembershipPermissionOverride - updated_at - updated at
   * * `ProjectInvitation.id` - ProjectInvitation - id - ID
   * * `ProjectInvitation.project` - ProjectInvitation - project - project
   * * `ProjectInvitation.name` - ProjectInvitation - name - Имя приглашённого
   * * `ProjectInvitation.email` - ProjectInvitation - email - Email приглашённого
   * * `ProjectInvitation.role` - ProjectInvitation - role - role
   * * `ProjectInvitation.preset` - ProjectInvitation - preset - preset
   * * `ProjectInvitation.invited_by` - ProjectInvitation - invited_by - invited by
   * * `ProjectInvitation.token` - ProjectInvitation - token - Токен
   * * `ProjectInvitation.status` - ProjectInvitation - status - status
   * * `ProjectInvitation.expires_at` - ProjectInvitation - expires_at - Действительно до
   * * `ProjectInvitation.created_at` - ProjectInvitation - created_at - created at
   * * `ProjectInvitation.updated_at` - ProjectInvitation - updated_at - updated at
   * * `AccessAuditLog.id` - AccessAuditLog - id - ID
   * * `AccessAuditLog.project` - AccessAuditLog - project - project
   * * `AccessAuditLog.actor` - AccessAuditLog - actor - Кто совершил действие
   * * `AccessAuditLog.target_user` - AccessAuditLog - target_user - Над кем совершено действие
   * * `AccessAuditLog.event` - AccessAuditLog - event - event
   * * `AccessAuditLog.payload` - AccessAuditLog - payload - Доп. данные события
   * * `AccessAuditLog.occurred_at` - AccessAuditLog - occurred_at - occurred at
   * * `Project.sources_of_financing` - projects - sources_of_financing - общее поле для источников финансирования
   * * `TaxPrm.ad_valorem_taxes` - taxes - ad_valorem_taxes - общее поле для адвалорных налогов
   * * `TaxPrm.hard_taxes` - taxes - hard_taxes - общее поле для твердых налогов
   * * `TaxPrm.modeling_of_tax_calculations` - taxes - modeling_of_tax_calculations - моделирование налоговых расчетов
   */
  field?:
    | 'AccessAuditLog.actor'
    | 'AccessAuditLog.event'
    | 'AccessAuditLog.id'
    | 'AccessAuditLog.occurred_at'
    | 'AccessAuditLog.payload'
    | 'AccessAuditLog.project'
    | 'AccessAuditLog.target_user'
    | 'ActualCapex.amount'
    | 'ActualCapex.created_at'
    | 'ActualCapex.created_by'
    | 'ActualCapex.date'
    | 'ActualCapex.depreciation_period'
    | 'ActualCapex.description'
    | 'ActualCapex.external_id'
    | 'ActualCapex.id'
    | 'ActualCapex.import_batch'
    | 'ActualCapex.is_leasing'
    | 'ActualCapex.name'
    | 'ActualCapex.planning_object_id'
    | 'ActualCapex.raw_payload'
    | 'ActualCapex.scenario'
    | 'ActualCapex.source'
    | 'ActualCapex.source_system'
    | 'ActualCapex.updated_at'
    | 'ActualCapex.vat_rate'
    | 'ActualCredit.amount'
    | 'ActualCredit.bank'
    | 'ActualCredit.created_at'
    | 'ActualCredit.created_by'
    | 'ActualCredit.date'
    | 'ActualCredit.description'
    | 'ActualCredit.external_id'
    | 'ActualCredit.id'
    | 'ActualCredit.import_batch'
    | 'ActualCredit.name'
    | 'ActualCredit.payment_type'
    | 'ActualCredit.planning_object_id'
    | 'ActualCredit.raw_payload'
    | 'ActualCredit.scenario'
    | 'ActualCredit.source'
    | 'ActualCredit.source_system'
    | 'ActualCredit.type'
    | 'ActualCredit.updated_at'
    | 'ActualLeasingContract.actual_capex'
    | 'ActualLeasingContract.amount'
    | 'ActualLeasingContract.created_at'
    | 'ActualLeasingContract.created_by'
    | 'ActualLeasingContract.date'
    | 'ActualLeasingContract.description'
    | 'ActualLeasingContract.external_id'
    | 'ActualLeasingContract.id'
    | 'ActualLeasingContract.import_batch'
    | 'ActualLeasingContract.lessor'
    | 'ActualLeasingContract.name'
    | 'ActualLeasingContract.payment_type'
    | 'ActualLeasingContract.planning_object_id'
    | 'ActualLeasingContract.raw_payload'
    | 'ActualLeasingContract.scenario'
    | 'ActualLeasingContract.source'
    | 'ActualLeasingContract.source_system'
    | 'ActualLeasingContract.updated_at'
    | 'ActualLeasingContract.vat_rate'
    | 'ActualMaterial.amount'
    | 'ActualMaterial.business_activity'
    | 'ActualMaterial.created_at'
    | 'ActualMaterial.created_by'
    | 'ActualMaterial.date'
    | 'ActualMaterial.description'
    | 'ActualMaterial.external_id'
    | 'ActualMaterial.id'
    | 'ActualMaterial.import_batch'
    | 'ActualMaterial.name'
    | 'ActualMaterial.planning_object_id'
    | 'ActualMaterial.provider'
    | 'ActualMaterial.raw_payload'
    | 'ActualMaterial.scenario'
    | 'ActualMaterial.source'
    | 'ActualMaterial.source_system'
    | 'ActualMaterial.updated_at'
    | 'ActualMaterial.vat_rate'
    | 'ActualOtherOpex.amount'
    | 'ActualOtherOpex.business_activity'
    | 'ActualOtherOpex.created_at'
    | 'ActualOtherOpex.created_by'
    | 'ActualOtherOpex.date'
    | 'ActualOtherOpex.description'
    | 'ActualOtherOpex.economic_activity'
    | 'ActualOtherOpex.external_id'
    | 'ActualOtherOpex.id'
    | 'ActualOtherOpex.import_batch'
    | 'ActualOtherOpex.name'
    | 'ActualOtherOpex.planning_object_id'
    | 'ActualOtherOpex.raw_payload'
    | 'ActualOtherOpex.scenario'
    | 'ActualOtherOpex.source'
    | 'ActualOtherOpex.source_system'
    | 'ActualOtherOpex.updated_at'
    | 'ActualOtherOpex.vat_rate'
    | 'ActualOwnFund.amount'
    | 'ActualOwnFund.created_at'
    | 'ActualOwnFund.created_by'
    | 'ActualOwnFund.date'
    | 'ActualOwnFund.description'
    | 'ActualOwnFund.external_id'
    | 'ActualOwnFund.id'
    | 'ActualOwnFund.import_batch'
    | 'ActualOwnFund.investor'
    | 'ActualOwnFund.name'
    | 'ActualOwnFund.planning_object_id'
    | 'ActualOwnFund.raw_payload'
    | 'ActualOwnFund.scenario'
    | 'ActualOwnFund.source'
    | 'ActualOwnFund.source_system'
    | 'ActualOwnFund.updated_at'
    | 'ActualProduct.amount'
    | 'ActualProduct.business_activity'
    | 'ActualProduct.created_at'
    | 'ActualProduct.created_by'
    | 'ActualProduct.date'
    | 'ActualProduct.description'
    | 'ActualProduct.external_id'
    | 'ActualProduct.id'
    | 'ActualProduct.import_batch'
    | 'ActualProduct.name'
    | 'ActualProduct.planning_object_id'
    | 'ActualProduct.provider'
    | 'ActualProduct.raw_payload'
    | 'ActualProduct.scenario'
    | 'ActualProduct.source'
    | 'ActualProduct.source_system'
    | 'ActualProduct.updated_at'
    | 'ActualProduct.vat_rate'
    | 'ActualRent.address'
    | 'ActualRent.amount'
    | 'ActualRent.area'
    | 'ActualRent.created_at'
    | 'ActualRent.created_by'
    | 'ActualRent.date'
    | 'ActualRent.description'
    | 'ActualRent.external_id'
    | 'ActualRent.id'
    | 'ActualRent.import_batch'
    | 'ActualRent.indexing_frequency'
    | 'ActualRent.indexing_value'
    | 'ActualRent.lessor'
    | 'ActualRent.name'
    | 'ActualRent.object_type'
    | 'ActualRent.planning_object_id'
    | 'ActualRent.price_indexation'
    | 'ActualRent.raw_payload'
    | 'ActualRent.scenario'
    | 'ActualRent.source'
    | 'ActualRent.source_system'
    | 'ActualRent.updated_at'
    | 'ActualRent.vat_rate'
    | 'ActualSalary.accounting_unit'
    | 'ActualSalary.amount'
    | 'ActualSalary.base_calculation_deal'
    | 'ActualSalary.calculate_insurance_contributions'
    | 'ActualSalary.created_at'
    | 'ActualSalary.created_by'
    | 'ActualSalary.date'
    | 'ActualSalary.department_name'
    | 'ActualSalary.description'
    | 'ActualSalary.employee_name'
    | 'ActualSalary.employee_position'
    | 'ActualSalary.external_id'
    | 'ActualSalary.id'
    | 'ActualSalary.import_batch'
    | 'ActualSalary.indexing_frequency'
    | 'ActualSalary.indexing_value'
    | 'ActualSalary.is_subject_to_social_tax'
    | 'ActualSalary.name'
    | 'ActualSalary.payment_type'
    | 'ActualSalary.personnel_type'
    | 'ActualSalary.planning_object_id'
    | 'ActualSalary.product_id'
    | 'ActualSalary.product_type'
    | 'ActualSalary.production_rate_amount'
    | 'ActualSalary.rate_sales_amount'
    | 'ActualSalary.raw_payload'
    | 'ActualSalary.scenario'
    | 'ActualSalary.source'
    | 'ActualSalary.source_system'
    | 'ActualSalary.updated_at'
    | 'ActualSalary.vat_rate'
    | 'ActualSale.amount'
    | 'ActualSale.created_at'
    | 'ActualSale.created_by'
    | 'ActualSale.date'
    | 'ActualSale.description'
    | 'ActualSale.external_id'
    | 'ActualSale.id'
    | 'ActualSale.import_batch'
    | 'ActualSale.planning_object_id'
    | 'ActualSale.product_name'
    | 'ActualSale.raw_payload'
    | 'ActualSale.scenario'
    | 'ActualSale.source'
    | 'ActualSale.source_system'
    | 'ActualSale.updated_at'
    | 'ActualSale.vat_rate'
    | 'ActualSale.volume'
    | 'ActualTax.amount'
    | 'ActualTax.created_at'
    | 'ActualTax.created_by'
    | 'ActualTax.date'
    | 'ActualTax.description'
    | 'ActualTax.external_id'
    | 'ActualTax.id'
    | 'ActualTax.import_batch'
    | 'ActualTax.name'
    | 'ActualTax.planning_object_id'
    | 'ActualTax.raw_payload'
    | 'ActualTax.scenario'
    | 'ActualTax.source'
    | 'ActualTax.source_system'
    | 'ActualTax.type'
    | 'ActualTax.updated_at'
    | 'ActualWorkingCapital.created_at'
    | 'ActualWorkingCapital.created_by'
    | 'ActualWorkingCapital.customer_accounts_receivable'
    | 'ActualWorkingCapital.customer_advances'
    | 'ActualWorkingCapital.external_id'
    | 'ActualWorkingCapital.id'
    | 'ActualWorkingCapital.import_batch'
    | 'ActualWorkingCapital.month'
    | 'ActualWorkingCapital.planning_object_id'
    | 'ActualWorkingCapital.raw_payload'
    | 'ActualWorkingCapital.scenario'
    | 'ActualWorkingCapital.source'
    | 'ActualWorkingCapital.source_system'
    | 'ActualWorkingCapital.supplier_accounts_payable'
    | 'ActualWorkingCapital.supplier_advances'
    | 'ActualWorkingCapital.tmc'
    | 'ActualWorkingCapital.updated_at'
    | 'ActualWorkingCapital.vat_balance_on_purchased_assets'
    | 'ActualWorkingCapital.year'
    | 'AdditionalProjectInformation.contract'
    | 'AdditionalProjectInformation.contract_date'
    | 'AdditionalProjectInformation.country'
    | 'AdditionalProjectInformation.full_name_person_responsible'
    | 'AdditionalProjectInformation.id'
    | 'AdditionalProjectInformation.init_date'
    | 'AdditionalProjectInformation.name_full'
    | 'AdditionalProjectInformation.project'
    | 'AdditionalProjectInformation.user_code'
    | 'AdvancedProduct.annual_inflation'
    | 'AdvancedProduct.available_market_size'
    | 'AdvancedProduct.call_conversion'
    | 'AdvancedProduct.end_date'
    | 'AdvancedProduct.group'
    | 'AdvancedProduct.id'
    | 'AdvancedProduct.is_blocked'
    | 'AdvancedProduct.name'
    | 'AdvancedProduct.potential_market_size'
    | 'AdvancedProduct.price'
    | 'AdvancedProduct.price_coeff'
    | 'AdvancedProduct.price_coeff_for_all_products'
    | 'AdvancedProduct.price_indexing_frequency'
    | 'AdvancedProduct.price_sensitivity_coefficient'
    | 'AdvancedProduct.purchase_conversion'
    | 'AdvancedProduct.quantity_pam'
    | 'AdvancedProduct.quantity_sam'
    | 'AdvancedProduct.quantity_tam'
    | 'AdvancedProduct.round_values_to_integer'
    | 'AdvancedProduct.sales_volume'
    | 'AdvancedProduct.sam_tam'
    | 'AdvancedProduct.start_date'
    | 'AdvancedProduct.subject_to_excise_duty'
    | 'AdvancedProduct.subject_to_ndpi'
    | 'AdvancedProduct.tam_pam'
    | 'AdvancedProduct.tax_rate'
    | 'AdvancedProduct.total_target_market'
    | 'AdvancedProduct.use_lead_generation'
    | 'AdvancedProduct.use_price_coeff'
    | 'AdvancedProduct.use_taxes'
    | 'AdvancedProduct.use_volume_coeff'
    | 'AdvancedProduct.variant'
    | 'AdvancedProduct.volume_coeff'
    | 'AdvancedProduct.volume_coeff_for_all_products'
    | 'AdvancedProduct.volume_indexing'
    | 'AdvancedProduct.volume_indexing_frequency'
    | 'AdvancedProduct.volume_unit'
    | 'AdvancedProductConversionField.id'
    | 'AdvancedProductConversionField.name'
    | 'AdvancedProductConversionField.product'
    | 'AdvancedProductConversionField.value'
    | 'AllertOrError.code'
    | 'AllertOrError.id'
    | 'AllertOrError.params'
    | 'AllertOrError.scenario'
    | 'AllertOrError.text'
    | 'AllertOrError.type'
    | 'AnnualAverage.average_annual_VAT'
    | 'AnnualAverage.average_annual_income_tax'
    | 'AnnualAverage.average_annual_net_profit'
    | 'AnnualAverage.average_annual_operating_costs'
    | 'AnnualAverage.average_annual_revenue'
    | 'AnnualAverage.average_return_on_sales'
    | 'AnnualAverage.id'
    | 'AnnualAverage.scenario'
    | 'Balance.accounts_payable'
    | 'Balance.accounts_payable'
    | 'Balance.accounts_receivable'
    | 'Balance.accounts_receivable'
    | 'Balance.authorized_share_capital'
    | 'Balance.authorized_share_capital'
    | 'Balance.borrowed_funds'
    | 'Balance.borrowed_funds'
    | 'Balance.cash'
    | 'Balance.cash'
    | 'Balance.date'
    | 'Balance.date'
    | 'Balance.fixed_assets'
    | 'Balance.fixed_assets'
    | 'Balance.id'
    | 'Balance.id'
    | 'Balance.intangible_assets'
    | 'Balance.investor_funds'
    | 'Balance.scenario'
    | 'Balance.scenario'
    | 'Balance.stocks'
    | 'Balance.stocks'
    | 'Balance.total_balance'
    | 'Balance.total_balance'
    | 'Balance.total_balance2'
    | 'Balance.total_balance2'
    | 'Balance.total_current_assets'
    | 'Balance.total_current_assets'
    | 'Balance.total_equity'
    | 'Balance.total_equity'
    | 'Balance.total_liabilities'
    | 'Balance.total_liabilities'
    | 'Balance.total_non_current_assets'
    | 'Balance.total_non_current_assets'
    | 'Balance.undestributed_profits'
    | 'Balance.undestributed_profits'
    | 'Balance.vat_purchased_assets'
    | 'Balance.vat_purchased_assets'
    | 'BasicIndicator.MIRR_internal_rate_return'
    | 'BasicIndicator.discount_rate'
    | 'BasicIndicator.id'
    | 'BasicIndicator.internal_rate_return_irr'
    | 'BasicIndicator.net_present_value_npv'
    | 'BasicIndicator.profitability_index_pi'
    | 'BasicIndicator.refinancing_rate'
    | 'BasicIndicator.scenario'
    | 'BasicIndicatorPeriodic.date'
    | 'BasicIndicatorPeriodic.id'
    | 'BasicIndicatorPeriodic.irr'
    | 'BasicIndicatorPeriodic.npv'
    | 'BasicIndicatorPeriodic.roi'
    | 'BasicIndicatorPeriodic.scenario'
    | 'BusinessAngel.angel_email'
    | 'BusinessAngel.angel_name'
    | 'BusinessAngel.id'
    | 'BusinessAngel.variant'
    | 'BusinessAngelDividend.amount'
    | 'BusinessAngelDividend.business_angel'
    | 'BusinessAngelDividend.created_at'
    | 'BusinessAngelDividend.date'
    | 'BusinessAngelDividend.id'
    | 'BusinessAngelDividend.interest_rate'
    | 'BusinessAngelDividend.name'
    | 'BusinessAngelDividend.repayment_periodicity'
    | 'BusinessAngelDividend.term'
    | 'BusinessAngelDividend.updated_at'
    | 'BusinessAngelLoan.amount'
    | 'BusinessAngelLoan.business_angel'
    | 'BusinessAngelLoan.created_at'
    | 'BusinessAngelLoan.date'
    | 'BusinessAngelLoan.id'
    | 'BusinessAngelLoan.interest_rate'
    | 'BusinessAngelLoan.name'
    | 'BusinessAngelLoan.repayment_periodicity'
    | 'BusinessAngelLoan.term'
    | 'BusinessAngelLoan.updated_at'
    | 'BusinessAngelVariant.id'
    | 'BusinessAngelVariant.project'
    | 'BusinessAngelVariant.variant_name'
    | 'Capex.VAT_rate'
    | 'Capex.VAT_refund'
    | 'Capex.amortization_premium'
    | 'Capex.amount_capital_expenditure'
    | 'Capex.deprication_period'
    | 'Capex.end_date'
    | 'Capex.group'
    | 'Capex.id'
    | 'Capex.intangible_asset'
    | 'Capex.is_blocked'
    | 'Capex.leasing_switch'
    | 'Capex.liquidation_cost'
    | 'Capex.liquidation_cost_VAT_rate'
    | 'Capex.liquidation_cost_switch'
    | 'Capex.liquidation_profit'
    | 'Capex.liquidation_profit_VAT_rate'
    | 'Capex.liquidation_profit_switch'
    | 'Capex.name'
    | 'Capex.start_date'
    | 'Capex.taxdeprication_period'
    | 'Capex.taxdeprication_switch'
    | 'Capex.variant'
    | 'CapexObject.address'
    | 'CapexObject.cadastral_number'
    | 'CapexObject.capex'
    | 'CapexObject.create_date'
    | 'CapexObject.farm'
    | 'CapexObject.id'
    | 'CapexObject.land_area'
    | 'CapexObject.name'
    | 'CapexObject.project_works'
    | 'CapexObjectFile.create_date'
    | 'CapexObjectFile.file'
    | 'CapexObjectFile.id'
    | 'CapexObjectFile.name'
    | 'CapexObjectFile.object'
    | 'CapexObjectFile.show_to_investors'
    | 'CapexVariant.create_date'
    | 'CapexVariant.id'
    | 'CapexVariant.is_blocked'
    | 'CapexVariant.project'
    | 'CapexVariant.variant_name'
    | 'CapexsGroup.id'
    | 'CapexsGroup.name'
    | 'CashFlowPlan.cash_balance_beginning_period'
    | 'CashFlowPlan.cash_balance_the_end_period'
    | 'CashFlowPlan.credit_receipt'
    | 'CashFlowPlan.date'
    | 'CashFlowPlan.dividends_payment'
    | 'CashFlowPlan.ebitda'
    | 'CashFlowPlan.id'
    | 'CashFlowPlan.income_tax'
    | 'CashFlowPlan.incoming_from_investors'
    | 'CashFlowPlan.interest_payment'
    | 'CashFlowPlan.net_cash_flow'
    | 'CashFlowPlan.net_cash_flow_from_financing_activities'
    | 'CashFlowPlan.net_cash_flow_from_investing_activities'
    | 'CashFlowPlan.net_cash_flow_from_operations'
    | 'CashFlowPlan.payment_capital_costs'
    | 'CashFlowPlan.payment_liquidation_expenses'
    | 'CashFlowPlan.payments_to_investors'
    | 'CashFlowPlan.receipt_from_owners'
    | 'CashFlowPlan.receipt_liquidation_proceeds'
    | 'CashFlowPlan.return_credits'
    | 'CashFlowPlan.scenario'
    | 'CashFlowPlan.vat_refund'
    | 'CashFlowPlan.working_weight_change'
    | 'CashFlowStatement.cash_balance_beginning_period'
    | 'CashFlowStatement.cash_balance_the_end_period'
    | 'CashFlowStatement.credit_receipt'
    | 'CashFlowStatement.date'
    | 'CashFlowStatement.ebitda'
    | 'CashFlowStatement.id'
    | 'CashFlowStatement.income_tax'
    | 'CashFlowStatement.interest_payment'
    | 'CashFlowStatement.net_cash_flow'
    | 'CashFlowStatement.net_cash_flow_from_financing_activities'
    | 'CashFlowStatement.net_cash_flow_from_investing_activities'
    | 'CashFlowStatement.net_cash_flow_from_operations'
    | 'CashFlowStatement.payment_capital_costs'
    | 'CashFlowStatement.payment_liquidation_expenses'
    | 'CashFlowStatement.receipt_from_owners'
    | 'CashFlowStatement.receipt_liquidation_proceeds'
    | 'CashFlowStatement.return_credits'
    | 'CashFlowStatement.scenario'
    | 'CashFlowStatement.vat_refund'
    | 'CashFlowStatement.working_weight_change'
    | 'Category.id'
    | 'Category.locale'
    | 'Category.name'
    | 'Category.nested_category'
    | 'ChatMessage.chat'
    | 'ChatMessage.id'
    | 'ChatMessage.is_read_by'
    | 'ChatMessage.message'
    | 'ChatMessage.sender'
    | 'ChatMessage.timestamp'
    | 'ChatRoom.id'
    | 'ChatRoom.members'
    | 'ChatRoom.name'
    | 'ChatRoom.project'
    | 'ChatRoom.room_id'
    | 'Coefficients.absolute_liquidity_ratio'
    | 'Coefficients.accounts_payable_turnover_ratio'
    | 'Coefficients.accounts_receivable_turnover_ratio'
    | 'Coefficients.asset_turnover_ratio'
    | 'Coefficients.autonomy_coefficient'
    | 'Coefficients.current_assets_turnover_ratio'
    | 'Coefficients.current_liquidity_ratio'
    | 'Coefficients.date'
    | 'Coefficients.id'
    | 'Coefficients.interim_liquidity_ratio'
    | 'Coefficients.inventory_turnover_ratio'
    | 'Coefficients.leverage_ratio_de'
    | 'Coefficients.own_working_capital_ratio'
    | 'Coefficients.return_on_assets_roa'
    | 'Coefficients.return_on_equity_roe'
    | 'Coefficients.return_on_sales_rot'
    | 'Coefficients.scenario'
    | 'Company.id'
    | 'Company.name'
    | 'Company.users'
    | 'ContentType.app_label'
    | 'ContentType.id'
    | 'ContentType.model'
    | 'CopiedProject.copied_project'
    | 'CopiedProject.ext_switch'
    | 'CopiedProject.finance_switch'
    | 'CopiedProject.id'
    | 'CopiedProject.name'
    | 'CopiedProject.project'
    | 'Country.code'
    | 'Country.currency'
    | 'Country.id'
    | 'Country.name'
    | 'Country.name_en'
    | 'Country.prefix'
    | 'Credit.calculation_type'
    | 'Credit.capex'
    | 'Credit.capitalization'
    | 'Credit.create_date'
    | 'Credit.date'
    | 'Credit.date_in'
    | 'Credit.grace_period_interest'
    | 'Credit.grace_period_principal'
    | 'Credit.id'
    | 'Credit.interest_rate'
    | 'Credit.is_blocked'
    | 'Credit.lender'
    | 'Credit.name'
    | 'Credit.sum_in_currancy'
    | 'Credit.tenor'
    | 'Credit.variant'
    | 'CreditVariant.capex_variant'
    | 'CreditVariant.create_date'
    | 'CreditVariant.id'
    | 'CreditVariant.is_blocked'
    | 'CreditVariant.project'
    | 'CreditVariant.variant_name'
    | 'Currency.id'
    | 'Currency.name'
    | 'Currency.name_en'
    | 'Currency.short_name'
    | 'DiscountCoupon.active'
    | 'DiscountCoupon.code'
    | 'DiscountCoupon.discount'
    | 'DiscountCoupon.id'
    | 'DiscountCoupon.tariff_plans'
    | 'DiscountCoupon.valid_from'
    | 'DiscountCoupon.valid_to'
    | 'DiscountRate.create_date'
    | 'DiscountRate.discount_rate_general_install'
    | 'DiscountRate.discount_rate_source'
    | 'DiscountRate.id'
    | 'DiscountRate.is_blocked'
    | 'DiscountRate.project'
    | 'DiscountRate.reinvesting_rate'
    | 'DiscountRate.reinvesting_rate_source'
    | 'DiscountRate.variant_name'
    | 'Feedback.feedback_text'
    | 'Feedback.feedback_type'
    | 'Feedback.id'
    | 'Feedback.rating'
    | 'Feedback.user'
    | 'FinancingSource.id'
    | 'FinancingSource.source_name'
    | 'FundingAmount.DE_ratio'
    | 'FundingAmount.amount_of_borrowed_funds'
    | 'FundingAmount.amount_of_own_funds'
    | 'FundingAmount.average_Debt_EBITDA_ratio'
    | 'FundingAmount.capEx_amount'
    | 'FundingAmount.id'
    | 'FundingAmount.scenario'
    | 'Group.id'
    | 'Group.name'
    | 'Group.permissions'
    | 'Helper.field'
    | 'Helper.id'
    | 'Helper.page'
    | 'Helper.text'
    | 'Helper.topic'
    | 'ImportBatch.created_at'
    | 'ImportBatch.created_by'
    | 'ImportBatch.error_report'
    | 'ImportBatch.error_rows'
    | 'ImportBatch.id'
    | 'ImportBatch.raw_payload'
    | 'ImportBatch.source'
    | 'ImportBatch.source_system'
    | 'ImportBatch.status'
    | 'ImportBatch.total_rows'
    | 'ImportBatch.updated_at'
    | 'ImportBatch.valid_rows'
    | 'ImportBatchRow.batch'
    | 'ImportBatchRow.created_at'
    | 'ImportBatchRow.errors'
    | 'ImportBatchRow.id'
    | 'ImportBatchRow.normalized_data'
    | 'ImportBatchRow.raw_data'
    | 'ImportBatchRow.row_number'
    | 'ImportBatchRow.target_model'
    | 'ImportBatchRow.target_object_id'
    | 'Industry.id'
    | 'Industry.locale'
    | 'Industry.name'
    | 'InvestorApplication.deal_status'
    | 'InvestorApplication.id'
    | 'InvestorApplication.investor'
    | 'InvestorApplication.processing_status'
    | 'InvestorApplication.project'
    | 'InvestorReport.accumulated_financial_result'
    | 'InvestorReport.cash_flow_payments'
    | 'InvestorReport.date'
    | 'InvestorReport.dividends'
    | 'InvestorReport.fixed_sum_payments'
    | 'InvestorReport.id'
    | 'InvestorReport.investment_amount'
    | 'InvestorReport.loan_interests'
    | 'InvestorReport.loan_return'
    | 'InvestorReport.realization_payments'
    | 'InvestorReport.sales_payments'
    | 'InvestorReport.scenario'
    | 'InvestorReport.venture_fund_id'
    | 'InvestorReport.venture_fund_name'
    | 'KeyRate.id'
    | 'KeyRate.rate'
    | 'LeasingContract.VAT_rate'
    | 'LeasingContract.capex'
    | 'LeasingContract.contract_start_date'
    | 'LeasingContract.create_date'
    | 'LeasingContract.distribution_redemption_switch'
    | 'LeasingContract.id'
    | 'LeasingContract.initial_payment'
    | 'LeasingContract.is_blocked'
    | 'LeasingContract.lessor'
    | 'LeasingContract.monthly_lease_payment'
    | 'LeasingContract.name'
    | 'LeasingContract.redemption_sum_general'
    | 'LeasingContract.term_leasing_contract'
    | 'LeasingContract.variant'
    | 'LeasingContractVariant.capex_variant'
    | 'LeasingContractVariant.create_date'
    | 'LeasingContractVariant.id'
    | 'LeasingContractVariant.is_blocked'
    | 'LeasingContractVariant.project'
    | 'LeasingContractVariant.variant_name'
    | 'LogEntry.action_flag'
    | 'LogEntry.action_time'
    | 'LogEntry.category'
    | 'LogEntry.change_message'
    | 'LogEntry.content_type'
    | 'LogEntry.id'
    | 'LogEntry.id'
    | 'LogEntry.message'
    | 'LogEntry.object_id'
    | 'LogEntry.object_repr'
    | 'LogEntry.project'
    | 'LogEntry.scenario'
    | 'LogEntry.timestamp'
    | 'LogEntry.user'
    | 'LogEntry.user'
    | 'MainParameter.end_date'
    | 'MainParameter.id'
    | 'MainParameter.scenario'
    | 'MainParameter.start_date'
    | 'Material.amount'
    | 'Material.business_activity'
    | 'Material.costs_correspond_to_sales_dates'
    | 'Material.end_date'
    | 'Material.id'
    | 'Material.include_in_profit_tax_calculation'
    | 'Material.indexing_frequency'
    | 'Material.indexing_value'
    | 'Material.is_blocked'
    | 'Material.name'
    | 'Material.price_indexation'
    | 'Material.product_id'
    | 'Material.product_type'
    | 'Material.provider'
    | 'Material.quantity_opexs'
    | 'Material.start_date'
    | 'Material.unit'
    | 'Material.variant'
    | 'Material.vat_rate'
    | 'MembershipPermissionOverride.action'
    | 'MembershipPermissionOverride.created_at'
    | 'MembershipPermissionOverride.id'
    | 'MembershipPermissionOverride.membership'
    | 'MembershipPermissionOverride.section'
    | 'MembershipPermissionOverride.state'
    | 'MembershipPermissionOverride.updated_at'
    | 'Opex.VAT_rate'
    | 'Opex.cost_types_by_economic_grouping'
    | 'Opex.create_date'
    | 'Opex.end_date'
    | 'Opex.group'
    | 'Opex.id'
    | 'Opex.is_blocked'
    | 'Opex.name'
    | 'Opex.one_time_opex'
    | 'Opex.opex_date'
    | 'Opex.price'
    | 'Opex.price_indexation'
    | 'Opex.product_id'
    | 'Opex.product_type'
    | 'Opex.production_volume'
    | 'Opex.quantity_opexs'
    | 'Opex.start_date'
    | 'Opex.tax'
    | 'Opex.type_tax'
    | 'Opex.types_business_activity_costs'
    | 'Opex.unit'
    | 'Opex.variant'
    | 'OpexVariant.id'
    | 'OpexVariant.id'
    | 'OpexVariant.is_blocked'
    | 'OpexVariant.is_blocked'
    | 'OpexVariant.product_varinat'
    | 'OpexVariant.product_varinat'
    | 'OpexVariant.project'
    | 'OpexVariant.project'
    | 'OpexVariant.variant_name'
    | 'OpexVariant.variant_name'
    | 'OpexsGroup.id'
    | 'OpexsGroup.id'
    | 'OpexsGroup.name'
    | 'OpexsGroup.name'
    | 'OrganizationForm.creation_date'
    | 'OrganizationForm.id'
    | 'OrganizationForm.name'
    | 'OrganizationForm.update_date'
    | 'OtherOpex.amount'
    | 'OtherOpex.business_activity'
    | 'OtherOpex.costs_correspond_to_sales_dates'
    | 'OtherOpex.economic_activity'
    | 'OtherOpex.end_date'
    | 'OtherOpex.id'
    | 'OtherOpex.include_in_profit_tax_calculation'
    | 'OtherOpex.indexing_frequency'
    | 'OtherOpex.indexing_value'
    | 'OtherOpex.is_blocked'
    | 'OtherOpex.name'
    | 'OtherOpex.price_indexation'
    | 'OtherOpex.product_id'
    | 'OtherOpex.product_type'
    | 'OtherOpex.quantity_opexs'
    | 'OtherOpex.start_date'
    | 'OtherOpex.unit'
    | 'OtherOpex.variant'
    | 'OtherOpex.vat_rate'
    | 'OwnFund.accrual_frequency'
    | 'OwnFund.create_date'
    | 'OwnFund.id'
    | 'OwnFund.is_blocked'
    | 'OwnFund.name'
    | 'OwnFund.ownership_share'
    | 'OwnFund.payment_due_days'
    | 'OwnFund.profit_share_percentage'
    | 'OwnFund.should_pay_dividends'
    | 'OwnFund.source_date'
    | 'OwnFund.source_investor'
    | 'OwnFund.source_sum'
    | 'OwnFund.variant'
    | 'OwnFundVariant.create_date'
    | 'OwnFundVariant.id'
    | 'OwnFundVariant.is_blocked'
    | 'OwnFundVariant.project'
    | 'OwnFundVariant.variant_name'
    | 'PaybackProject.discounted_payback_exists'
    | 'PaybackProject.discounted_payback_parts'
    | 'PaybackProject.discounted_payback_period'
    | 'PaybackProject.id'
    | 'PaybackProject.nominal_payback_exists'
    | 'PaybackProject.nominal_payback_parts'
    | 'PaybackProject.nominal_payback_period'
    | 'PaybackProject.nominal_payback_period_in_years'
    | 'PaybackProject.scenario'
    | 'Payment.confirmation_url'
    | 'Payment.created_at'
    | 'Payment.id'
    | 'Payment.order_id'
    | 'Payment.payment_id'
    | 'Payment.payment_method_id'
    | 'Payment.payment_period'
    | 'Payment.status'
    | 'Payment.tariff_plan'
    | 'Payment.updated_at'
    | 'Payment.user'
    | 'PaymentPeriod.description'
    | 'PaymentPeriod.id'
    | 'PaymentPeriod.name'
    | 'PaymentPeriod.period'
    | 'PaymentPeriod.price'
    | 'PaymentPeriod.tariff_plan'
    | 'Permission.codename'
    | 'Permission.content_type'
    | 'Permission.id'
    | 'Permission.name'
    | 'PnLStatement.business_expenses'
    | 'PnLStatement.cost_price'
    | 'PnLStatement.date'
    | 'PnLStatement.ebitda'
    | 'PnLStatement.fixed_opexs'
    | 'PnLStatement.gross_profit'
    | 'PnLStatement.id'
    | 'PnLStatement.income_tax'
    | 'PnLStatement.interest_expenses'
    | 'PnLStatement.management_expenses'
    | 'PnLStatement.net_profit'
    | 'PnLStatement.operating_income_ebit'
    | 'PnLStatement.profit_before_tax'
    | 'PnLStatement.revenue'
    | 'PnLStatement.scenario'
    | 'PnLStatement.variables_opexs'
    | 'PolicyConfFile.create_date'
    | 'PolicyConfFile.file'
    | 'PolicyConfFile.id'
    | 'Product.NDPI'
    | 'Product.VAT'
    | 'Product.amount'
    | 'Product.business_activity'
    | 'Product.costs_correspond_to_sales_dates'
    | 'Product.end_date'
    | 'Product.end_date'
    | 'Product.excise_duty'
    | 'Product.id'
    | 'Product.id'
    | 'Product.include_in_profit_tax_calculation'
    | 'Product.indexing_frequency'
    | 'Product.indexing_value'
    | 'Product.inflation_indexation'
    | 'Product.inflation_indexation_period'
    | 'Product.is_blocked'
    | 'Product.is_blocked'
    | 'Product.name'
    | 'Product.name'
    | 'Product.price'
    | 'Product.price_indexation'
    | 'Product.product_id'
    | 'Product.product_type'
    | 'Product.product_unit'
    | 'Product.provider'
    | 'Product.quantity_opexs'
    | 'Product.sales_volume'
    | 'Product.start_date'
    | 'Product.start_date'
    | 'Product.unit'
    | 'Product.value_indexation'
    | 'Product.value_indexation_period'
    | 'Product.variant'
    | 'Product.variant'
    | 'Product.vat_rate'
    | 'ProductGroup.create_date'
    | 'ProductGroup.id'
    | 'ProductGroup.name'
    | 'ProductGroup.variant'
    | 'ProductVariant.calculation_tab'
    | 'ProductVariant.create_date'
    | 'ProductVariant.id'
    | 'ProductVariant.is_blocked'
    | 'ProductVariant.project'
    | 'ProductVariant.variant_name'
    | 'ProfitAndLossPlan.business_expenses'
    | 'ProfitAndLossPlan.cost_price'
    | 'ProfitAndLossPlan.date'
    | 'ProfitAndLossPlan.ebit_to_interest'
    | 'ProfitAndLossPlan.ebitda'
    | 'ProfitAndLossPlan.fixed_opexs'
    | 'ProfitAndLossPlan.gross_profit'
    | 'ProfitAndLossPlan.id'
    | 'ProfitAndLossPlan.income_tax'
    | 'ProfitAndLossPlan.interest_expenses'
    | 'ProfitAndLossPlan.management_expenses'
    | 'ProfitAndLossPlan.net_profit'
    | 'ProfitAndLossPlan.operating_income_ebit'
    | 'ProfitAndLossPlan.profit_before_tax'
    | 'ProfitAndLossPlan.revenue'
    | 'ProfitAndLossPlan.scenario'
    | 'ProfitAndLossPlan.variables_opexs'
    | 'Project.active'
    | 'Project.author'
    | 'Project.category'
    | 'Project.comments'
    | 'Project.country'
    | 'Project.create_date'
    | 'Project.currency'
    | 'Project.currency_multiplication'
    | 'Project.deletion_date'
    | 'Project.duration'
    | 'Project.fin_source_business_angel'
    | 'Project.fin_source_credit'
    | 'Project.fin_source_equity'
    | 'Project.fin_source_leasing'
    | 'Project.fin_source_venture'
    | 'Project.financing_type'
    | 'Project.full_description'
    | 'Project.id'
    | 'Project.industry_main'
    | 'Project.industry_segments'
    | 'Project.irr'
    | 'Project.is_blocked'
    | 'Project.is_ml_project'
    | 'Project.is_public'
    | 'Project.logo'
    | 'Project.name'
    | 'Project.npv'
    | 'Project.payback'
    | 'Project.rating'
    | 'Project.region'
    | 'Project.roe'
    | 'Project.roi'
    | 'Project.short_description'
    | 'Project.show_rating_to_investors'
    | 'Project.sources_of_financing'
    | 'Project.start_date'
    | 'Project.subscribers'
    | 'Project.tariff'
    | 'Project.time_detalization'
    | 'Project.update_date'
    | 'Project.use_purchases'
    | 'Project.years_to_payback'
    | 'ProjectCompany.company_sme'
    | 'ProjectCompany.date_init'
    | 'ProjectCompany.id'
    | 'ProjectCompany.name'
    | 'ProjectCompany.organization_form'
    | 'ProjectCompany.project'
    | 'ProjectConfig.detail_level'
    | 'ProjectConfig.equipment_property'
    | 'ProjectConfig.financing_sources'
    | 'ProjectConfig.id'
    | 'ProjectConfig.industry'
    | 'ProjectConfig.mode'
    | 'ProjectConfig.personnel_needed'
    | 'ProjectConfig.project'
    | 'ProjectConfig.property_needed'
    | 'ProjectConfig.raw_materials_needed'
    | 'ProjectConfig.sales_model'
    | 'ProjectConfig.scale'
    | 'ProjectConfig.tax_mode'
    | 'ProjectConfig.tax_rate'
    | 'ProjectConfig.use_eskhn'
    | 'ProjectConfig.working_capital_calculation'
    | 'ProjectField.desirable'
    | 'ProjectField.field'
    | 'ProjectField.id'
    | 'ProjectField.required'
    | 'ProjectFile.file'
    | 'ProjectFile.file_type'
    | 'ProjectFile.id'
    | 'ProjectFile.name'
    | 'ProjectFile.project'
    | 'ProjectFile.show_to_investors'
    | 'ProjectInvitation.created_at'
    | 'ProjectInvitation.email'
    | 'ProjectInvitation.expires_at'
    | 'ProjectInvitation.id'
    | 'ProjectInvitation.invited_by'
    | 'ProjectInvitation.name'
    | 'ProjectInvitation.preset'
    | 'ProjectInvitation.project'
    | 'ProjectInvitation.role'
    | 'ProjectInvitation.status'
    | 'ProjectInvitation.token'
    | 'ProjectInvitation.updated_at'
    | 'ProjectMembership.created_at'
    | 'ProjectMembership.id'
    | 'ProjectMembership.preset'
    | 'ProjectMembership.project'
    | 'ProjectMembership.role'
    | 'ProjectMembership.status'
    | 'ProjectMembership.updated_at'
    | 'ProjectMembership.user'
    | 'ProjectTab.filled'
    | 'ProjectTab.id'
    | 'ProjectTab.project'
    | 'ProjectTab.tab'
    | 'Rating.comment'
    | 'Rating.comment_code'
    | 'Rating.comment_params'
    | 'Rating.id'
    | 'Rating.rating'
    | 'Rating.scenario'
    | 'Region.code'
    | 'Region.country'
    | 'Region.description'
    | 'Region.id'
    | 'Region.name'
    | 'Rent.address'
    | 'Rent.amount'
    | 'Rent.area'
    | 'Rent.costs_correspond_to_sales_dates'
    | 'Rent.end_date'
    | 'Rent.id'
    | 'Rent.include_in_profit_tax_calculation'
    | 'Rent.indexing_frequency'
    | 'Rent.indexing_value'
    | 'Rent.is_blocked'
    | 'Rent.lessor'
    | 'Rent.name'
    | 'Rent.object_type'
    | 'Rent.price_indexation'
    | 'Rent.product_id'
    | 'Rent.product_type'
    | 'Rent.start_date'
    | 'Rent.variant'
    | 'Rent.vat_rate'
    | 'Requisites.file'
    | 'Requisites.id'
    | 'Requisites.name'
    | 'ResultFinancialAnalys.absolute_liquidity_ratio'
    | 'ResultFinancialAnalys.accounts_payable_turnover_ratio'
    | 'ResultFinancialAnalys.accounts_receivable_turnover_ratio'
    | 'ResultFinancialAnalys.asset_turnover_ratio'
    | 'ResultFinancialAnalys.autonomy_coefficient'
    | 'ResultFinancialAnalys.current_assets_turnover_ratio'
    | 'ResultFinancialAnalys.current_liquidity_ratio'
    | 'ResultFinancialAnalys.date'
    | 'ResultFinancialAnalys.debt_to_ebitda'
    | 'ResultFinancialAnalys.id'
    | 'ResultFinancialAnalys.interim_liquidity_ratio'
    | 'ResultFinancialAnalys.inventory_turnover_ratio'
    | 'ResultFinancialAnalys.leverage_ratio_de'
    | 'ResultFinancialAnalys.own_working_capital_ratio'
    | 'ResultFinancialAnalys.return_on_assets_roa'
    | 'ResultFinancialAnalys.return_on_equity_roe'
    | 'ResultFinancialAnalys.return_on_sales_rot'
    | 'ResultFinancialAnalys.scenario'
    | 'RolePreset.created_at'
    | 'RolePreset.description'
    | 'RolePreset.id'
    | 'RolePreset.is_system'
    | 'RolePreset.name'
    | 'RolePreset.owner'
    | 'RolePreset.updated_at'
    | 'RolePresetPermission.action'
    | 'RolePresetPermission.id'
    | 'RolePresetPermission.preset'
    | 'RolePresetPermission.section'
    | 'RolePresetPermission.state'
    | 'Salary.accounting_unit'
    | 'Salary.amount'
    | 'Salary.base_calculation_deal'
    | 'Salary.calculate_insurance_contributions'
    | 'Salary.costs_correspond_to_sales_dates'
    | 'Salary.department_name'
    | 'Salary.employee_name'
    | 'Salary.employee_position'
    | 'Salary.end_date'
    | 'Salary.id'
    | 'Salary.include_in_profit_tax_calculation'
    | 'Salary.indexing_frequency'
    | 'Salary.indexing_value'
    | 'Salary.is_blocked'
    | 'Salary.is_subject_to_ndfl'
    | 'Salary.is_subject_to_social_tax'
    | 'Salary.name'
    | 'Salary.payment_type'
    | 'Salary.payout_amount'
    | 'Salary.personnel_type'
    | 'Salary.piece_rate_percentage'
    | 'Salary.price_indexation'
    | 'Salary.product_id'
    | 'Salary.product_type'
    | 'Salary.start_date'
    | 'Salary.variant'
    | 'Salary.vat_rate'
    | 'SalesProductPlan.date'
    | 'SalesProductPlan.id'
    | 'SalesProductPlan.price'
    | 'SalesProductPlan.product_id'
    | 'SalesProductPlan.product_name'
    | 'SalesProductPlan.revenue_with_vat'
    | 'SalesProductPlan.revenue_without_vat'
    | 'SalesProductPlan.scenario'
    | 'SalesProductPlan.vat'
    | 'SalesProductPlan.volume'
    | 'Scenario.calculation_data'
    | 'Scenario.desc'
    | 'Scenario.id'
    | 'Scenario.is_blocked'
    | 'Scenario.is_public'
    | 'Scenario.name'
    | 'Scenario.needs_recalculation'
    | 'Scenario.project'
    | 'Scenario.variant_capex'
    | 'Scenario.variant_credits'
    | 'Scenario.variant_discount_rate'
    | 'Scenario.variant_leasing'
    | 'Scenario.variant_opexs'
    | 'Scenario.variant_own_funds'
    | 'Scenario.variant_sales'
    | 'Scenario.variant_taxs'
    | 'Scenario.variant_venture_funds'
    | 'Scenario.variant_wk'
    | 'ScenarioSettings.financial_data_changed'
    | 'ScenarioSettings.id'
    | 'ScenarioSettings.scenario'
    | 'ScenarioSettings.updated_at'
    | 'Segment.id'
    | 'Segment.industry'
    | 'Segment.name'
    | 'Segment.name_en'
    | 'Session.expire_date'
    | 'Session.session_data'
    | 'Session.session_key'
    | 'Sphere.id'
    | 'Sphere.locale'
    | 'Sphere.name'
    | 'SpreadsheetConfig.config'
    | 'SpreadsheetConfig.id'
    | 'SpreadsheetConfig.product'
    | 'StandardProduct.annual_growth_rate'
    | 'StandardProduct.annual_inflation'
    | 'StandardProduct.available_market_size'
    | 'StandardProduct.call_conversion'
    | 'StandardProduct.group'
    | 'StandardProduct.id'
    | 'StandardProduct.is_blocked'
    | 'StandardProduct.name'
    | 'StandardProduct.potential_market_size'
    | 'StandardProduct.price'
    | 'StandardProduct.purchase_conversion'
    | 'StandardProduct.quantity_pam'
    | 'StandardProduct.quantity_sam'
    | 'StandardProduct.quantity_tam'
    | 'StandardProduct.round_values_to_integer'
    | 'StandardProduct.sales_duration'
    | 'StandardProduct.sales_volume'
    | 'StandardProduct.sam_tam'
    | 'StandardProduct.start_date'
    | 'StandardProduct.tam_pam'
    | 'StandardProduct.tax_rate'
    | 'StandardProduct.total_target_market'
    | 'StandardProduct.use_lead_generation'
    | 'StandardProduct.variant'
    | 'StandardProduct.volume_unit'
    | 'StandartProductConversionField.id'
    | 'StandartProductConversionField.name'
    | 'StandartProductConversionField.product'
    | 'StandartProductConversionField.value'
    | 'Subscription.active'
    | 'Subscription.created_at'
    | 'Subscription.ends_at'
    | 'Subscription.payment'
    | 'Subscription.renewal'
    | 'Subscription.tariff_plan'
    | 'Subscription.user'
    | 'Subscription.uuid'
    | 'SupportRequest.creation_date'
    | 'SupportRequest.id'
    | 'SupportRequest.status_processing'
    | 'SupportRequest.user'
    | 'TabularProduct.date_row_number'
    | 'TabularProduct.excise_row_number'
    | 'TabularProduct.id'
    | 'TabularProduct.name'
    | 'TabularProduct.ndpi_row_number'
    | 'TabularProduct.price_row_number'
    | 'TabularProduct.revenue_with_vat_row_number'
    | 'TabularProduct.revenue_without_vat_row_number'
    | 'TabularProduct.variant'
    | 'TabularProduct.vat_row_number'
    | 'TabularProduct.volume_row_number'
    | 'TabularProductData.date'
    | 'TabularProductData.excise'
    | 'TabularProductData.id'
    | 'TabularProductData.ndpi'
    | 'TabularProductData.price'
    | 'TabularProductData.product'
    | 'TabularProductData.revenue_with_vat'
    | 'TabularProductData.revenue_without_vat'
    | 'TabularProductData.vat'
    | 'TabularProductData.volume'
    | 'TamSamPamSomChart.id'
    | 'TamSamPamSomChart.pam'
    | 'TamSamPamSomChart.product_id'
    | 'TamSamPamSomChart.product_name'
    | 'TamSamPamSomChart.sam'
    | 'TamSamPamSomChart.scenario'
    | 'TamSamPamSomChart.som'
    | 'TamSamPamSomChart.tam'
    | 'TariffPermissions.allowed_periods'
    | 'TariffPermissions.balance_view'
    | 'TariffPermissions.block_advanced_products'
    | 'TariffPermissions.block_distribution_ransom_payment'
    | 'TariffPermissions.block_lead_generation'
    | 'TariffPermissions.block_leasings'
    | 'TariffPermissions.block_purshaces'
    | 'TariffPermissions.block_sales_plan'
    | 'TariffPermissions.block_schedule'
    | 'TariffPermissions.block_special_modes'
    | 'TariffPermissions.block_standard_taxes'
    | 'TariffPermissions.credit_capitalization'
    | 'TariffPermissions.financial_analysis_results'
    | 'TariffPermissions.grace_period_credit'
    | 'TariffPermissions.hard_taxs'
    | 'TariffPermissions.id'
    | 'TariffPermissions.income_tax_independent'
    | 'TariffPermissions.liquidation_expenses_and_income'
    | 'TariffPermissions.load_files'
    | 'TariffPermissions.max_capexs'
    | 'TariffPermissions.max_credits'
    | 'TariffPermissions.max_leasings'
    | 'TariffPermissions.max_loan_term'
    | 'TariffPermissions.max_opexs'
    | 'TariffPermissions.max_own_funds'
    | 'TariffPermissions.max_products'
    | 'TariffPermissions.max_projects'
    | 'TariffPermissions.max_sales_duration'
    | 'TariffPermissions.max_variant_collections'
    | 'TariffPermissions.max_variants'
    | 'TariffPermissions.output_to_excel'
    | 'TariffPermissions.project_shelf_life'
    | 'TariffPermissions.tariff'
    | 'TariffPermissions.vat_refund'
    | 'TariffPermissions.view_rating'
    | 'TariffPlan.active'
    | 'TariffPlan.description'
    | 'TariffPlan.id'
    | 'TariffPlan.is_for_investors'
    | 'TariffPlan.name'
    | 'TariffPlan.projects_create_limit'
    | 'TariffPlan.projects_invite_limit'
    | 'TariffPlan.projects_storage_finish_limit'
    | 'TariffPlan.projects_storage_start_limit'
    | 'TariffPlan.short_description'
    | 'TariffPlanAfterVerify.id'
    | 'TariffPlanAfterVerify.period'
    | 'TariffPlanAfterVerify.tariff_plan'
    | 'TaxMin.calculation_frequency'
    | 'TaxMin.create_date'
    | 'TaxMin.id'
    | 'TaxMin.is_blocked'
    | 'TaxMin.tax'
    | 'TaxMin.tax_burden'
    | 'TaxMin.tax_burden_base'
    | 'TaxPrm.ad_valorem_taxes'
    | 'TaxPrm.allowance_excise'
    | 'TaxPrm.allowance_ndpi'
    | 'TaxPrm.calculation_frequency'
    | 'TaxPrm.create_date'
    | 'TaxPrm.hard_taxes'
    | 'TaxPrm.id'
    | 'TaxPrm.income_tax'
    | 'TaxPrm.is_blocked'
    | 'TaxPrm.modeling_of_tax_calculations'
    | 'TaxPrm.multiplier_excise'
    | 'TaxPrm.multiplier_ndpi'
    | 'TaxPrm.project'
    | 'TaxPrm.social_tax'
    | 'TaxPrm.summ_excise'
    | 'TaxPrm.summ_ndpi'
    | 'TaxPrm.tax_min_burden'
    | 'TaxPrm.tax_min_burden_base'
    | 'TaxPrm.tax_simulation'
    | 'TaxPrm.variant_name'
    | 'TaxPrm.vat_export_rate'
    | 'TaxPrm.vat_preferential_rate'
    | 'TaxPrm.vat_standart_rate'
    | 'TaxSpecial.accident_tax'
    | 'TaxSpecial.annual_contribution_indexation_usn_income'
    | 'TaxSpecial.annual_contribution_indexation_usn_income_expenses'
    | 'TaxSpecial.annual_contribution_usn_income'
    | 'TaxSpecial.annual_contribution_usn_income_expenses'
    | 'TaxSpecial.create_date'
    | 'TaxSpecial.id'
    | 'TaxSpecial.is_blocked'
    | 'TaxSpecial.minimum_tax_usn_income_expenses'
    | 'TaxSpecial.ndfl'
    | 'TaxSpecial.social_tax'
    | 'TaxSpecial.tax'
    | 'TaxSpecial.tax_rate_eshn'
    | 'TaxSpecial.tax_rate_individuals'
    | 'TaxSpecial.tax_rate_legal_entities'
    | 'TaxSpecial.tax_rate_usn_income'
    | 'TaxSpecial.tax_rate_usn_income_expenses'
    | 'TaxSpecial.tax_regime'
    | 'TaxStandard.accident_tax'
    | 'TaxStandard.allowance_excise'
    | 'TaxStandard.allowance_ndpi'
    | 'TaxStandard.create_date'
    | 'TaxStandard.id'
    | 'TaxStandard.income_tax'
    | 'TaxStandard.is_blocked'
    | 'TaxStandard.multiplier_excise'
    | 'TaxStandard.multiplier_ndpi'
    | 'TaxStandard.ndfl'
    | 'TaxStandard.social_tax'
    | 'TaxStandard.summ_excise'
    | 'TaxStandard.summ_ndpi'
    | 'TaxStandard.tax'
    | 'TaxStandard.vat_export_rate'
    | 'TaxStandard.vat_preferential_rate'
    | 'TaxStandard.vat_standard_rate'
    | 'TermsServiceFile.create_date'
    | 'TermsServiceFile.file'
    | 'TermsServiceFile.id'
    | 'Token.created'
    | 'Token.key'
    | 'Token.user'
    | 'Topic.category'
    | 'Topic.examples'
    | 'Topic.id'
    | 'Topic.locale'
    | 'Topic.name'
    | 'Topic.theory'
    | 'TopicFile.file'
    | 'TopicFile.id'
    | 'TopicFile.name'
    | 'TotalSalesPlan.date'
    | 'TotalSalesPlan.id'
    | 'TotalSalesPlan.price'
    | 'TotalSalesPlan.revenue_with_vat'
    | 'TotalSalesPlan.revenue_without_vat'
    | 'TotalSalesPlan.scenario'
    | 'TotalSalesPlan.vat'
    | 'TotalSalesPlan.volume'
    | 'TranslationToken.description'
    | 'TranslationToken.id'
    | 'TranslationToken.key'
    | 'TranslationValue.id'
    | 'TranslationValue.locale'
    | 'TranslationValue.token'
    | 'TranslationValue.value'
    | 'User.auth_source'
    | 'User.create_date'
    | 'User.email'
    | 'User.first_name'
    | 'User.groups'
    | 'User.id'
    | 'User.is_active'
    | 'User.is_confirmation_sent'
    | 'User.is_email_verified'
    | 'User.is_onboarding_completed'
    | 'User.is_online'
    | 'User.is_staff'
    | 'User.is_superuser'
    | 'User.last_calculation_date'
    | 'User.last_ldap_login_at'
    | 'User.last_ldap_sync_at'
    | 'User.last_login'
    | 'User.last_name'
    | 'User.ldap_dn'
    | 'User.ldap_uid'
    | 'User.password'
    | 'User.patronymic'
    | 'User.pending_freeipa_password'
    | 'User.phone_number'
    | 'User.position'
    | 'User.sphere'
    | 'User.user_permissions'
    | 'User.user_type'
    | 'VentureFund.fund_email'
    | 'VentureFund.fund_name'
    | 'VentureFund.id'
    | 'VentureFund.investment_name'
    | 'VentureFund.variant'
    | 'VentureFundDividend.accrual_periodicity'
    | 'VentureFundDividend.amount'
    | 'VentureFundDividend.calculation_base'
    | 'VentureFundDividend.created_at'
    | 'VentureFundDividend.date'
    | 'VentureFundDividend.dividend_share'
    | 'VentureFundDividend.id'
    | 'VentureFundDividend.payment_term_days'
    | 'VentureFundDividend.updated_at'
    | 'VentureFundDividend.venture_fund'
    | 'VentureFundLoan.amount'
    | 'VentureFundLoan.created_at'
    | 'VentureFundLoan.date'
    | 'VentureFundLoan.id'
    | 'VentureFundLoan.interest_rate'
    | 'VentureFundLoan.name'
    | 'VentureFundLoan.repayment_periodicity'
    | 'VentureFundLoan.term'
    | 'VentureFundLoan.updated_at'
    | 'VentureFundLoan.venture_fund'
    | 'VentureFundVariant.id'
    | 'VentureFundVariant.project'
    | 'VentureFundVariant.variant_name'
    | 'WorkingCapitalParameter.create_date'
    | 'WorkingCapitalParameter.id'
    | 'WorkingCapitalParameter.is_blocked'
    | 'WorkingCapitalParameter.percentage_immediate_pay_sales'
    | 'WorkingCapitalParameter.project'
    | 'WorkingCapitalParameter.share_advance_purchase_general'
    | 'WorkingCapitalParameter.share_advance_sales_general'
    | 'WorkingCapitalParameter.share_cash_sales_general'
    | 'WorkingCapitalParameter.share_deferred_sales_general'
    | 'WorkingCapitalParameter.share_different_purchase_general'
    | 'WorkingCapitalParameter.share_purchases_with_immediate_payment'
    | 'WorkingCapitalParameter.turnover_advance_purchase_general'
    | 'WorkingCapitalParameter.turnover_advance_sales_general'
    | 'WorkingCapitalParameter.turnover_deferred_sales_general'
    | 'WorkingCapitalParameter.turnover_different_purchase_general'
    | 'WorkingCapitalParameter.turnover_inventory_general'
    | 'WorkingCapitalParameter.turnover_vat_general'
    | 'WorkingCapitalParameter.variant_name'
    | 'WorkingCapitalParameter.wc_end_switch';

  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
  page?: string;

  /**
   * A search term.
   */
  search?: string;
}

export function handbookHelpersList(
  http: HttpClient,
  rootUrl: string,
  params?: HandbookHelpersList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendHelperDto>>> {
  const rb = new RequestBuilder(rootUrl, handbookHelpersList.PATH, 'get');
  if (params) {
    rb.query('field', params.field, {});
    rb.query('ordering', params.ordering, {});
    rb.query('page', params.page, {});
    rb.query('search', params.search, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendHelperDto>>;
    }),
  );
}

handbookHelpersList.PATH = '/api/handbook/helpers/';
